/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermosDeUsoRouteImport } from './routes/termos-de-uso'
import { Route as SystemLoginRouteImport } from './routes/system-login'
import { Route as SsoRouteImport } from './routes/sso'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PoliticaPrivacidadeRouteImport } from './routes/politica-privacidade'
import { Route as PoliticaCookieRouteImport } from './routes/politica-cookie'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GoogleDriveOauthCallbackRouteImport } from './routes/google-drive-oauth-callback'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ExclusaoDeDadosRouteImport } from './routes/exclusao-de-dados'
import { Route as CalendarOauthCallbackRouteImport } from './routes/calendar-oauth-callback'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SystemRouteRouteImport } from './routes/system/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SystemIndexRouteImport } from './routes/system/index'
import { Route as SystemUsersRouteImport } from './routes/system/users'
import { Route as SystemTenantsRouteImport } from './routes/system/tenants'
import { Route as SystemTenantUsageRouteImport } from './routes/system/tenant-usage'
import { Route as SystemSupportRouteImport } from './routes/system/support'
import { Route as SystemSettingsRouteImport } from './routes/system/settings'
import { Route as SystemPlansRouteImport } from './routes/system/plans'
import { Route as SystemLogsRouteImport } from './routes/system/logs'
import { Route as SystemDevicesRouteImport } from './routes/system/devices'
import { Route as SystemAiCreditPackagesRouteImport } from './routes/system/ai-credit-packages'
import { Route as AuthenticatedWhatsappConfigRouteImport } from './routes/_authenticated/whatsapp-config'
import { Route as AuthenticatedUsersBirthdaysRouteImport } from './routes/_authenticated/users-birthdays'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedTeamsRouteImport } from './routes/_authenticated/teams'
import { Route as AuthenticatedTeamCalendarRouteImport } from './routes/_authenticated/team-calendar'
import { Route as AuthenticatedTasksHistoryRouteImport } from './routes/_authenticated/tasks-history'
import { Route as AuthenticatedTasksBoardRouteImport } from './routes/_authenticated/tasks-board'
import { Route as AuthenticatedTaskPlanningCalendarRouteImport } from './routes/_authenticated/task-planning-calendar'
import { Route as AuthenticatedTaskManagementRouteImport } from './routes/_authenticated/task-management'
import { Route as AuthenticatedStoreRouteImport } from './routes/_authenticated/store'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedRolesRouteImport } from './routes/_authenticated/roles'
import { Route as AuthenticatedRequestsRouteImport } from './routes/_authenticated/requests'
import { Route as AuthenticatedRemoteCommandsRouteImport } from './routes/_authenticated/remote-commands'
import { Route as AuthenticatedRealtimeRouteImport } from './routes/_authenticated/realtime'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedPointsDashboardRouteImport } from './routes/_authenticated/points-dashboard'
import { Route as AuthenticatedPasswordsRouteImport } from './routes/_authenticated/passwords'
import { Route as AuthenticatedOmnichannelTwilioConfigRouteImport } from './routes/_authenticated/omnichannel-twilio-config'
import { Route as AuthenticatedOmnichannelTwilioRouteImport } from './routes/_authenticated/omnichannel-twilio'
import { Route as AuthenticatedOfficeCalendarConfigRouteImport } from './routes/_authenticated/office-calendar-config'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedNotebookRouteImport } from './routes/_authenticated/notebook'
import { Route as AuthenticatedMyRequestsRouteImport } from './routes/_authenticated/my-requests'
import { Route as AuthenticatedMyPasswordsRouteImport } from './routes/_authenticated/my-passwords'
import { Route as AuthenticatedMyDashboardRouteImport } from './routes/_authenticated/my-dashboard'
import { Route as AuthenticatedMinhaEmpresaRouteImport } from './routes/_authenticated/minha-empresa'
import { Route as AuthenticatedMindmapsRouteImport } from './routes/_authenticated/mindmaps'
import { Route as AuthenticatedMetaOmnichannelConfigRouteImport } from './routes/_authenticated/meta-omnichannel-config'
import { Route as AuthenticatedMetaOmnichannelRouteImport } from './routes/_authenticated/meta-omnichannel'
import { Route as AuthenticatedMattermostSyncChannelsRouteImport } from './routes/_authenticated/mattermost-sync-channels'
import { Route as AuthenticatedMattermostScheduledMessagesRouteImport } from './routes/_authenticated/mattermost-scheduled-messages'
import { Route as AuthenticatedMattermostImageValidationRouteImport } from './routes/_authenticated/mattermost-image-validation'
import { Route as AuthenticatedMattermostConfigRouteImport } from './routes/_authenticated/mattermost-config'
import { Route as AuthenticatedKanbanRouteImport } from './routes/_authenticated/kanban'
import { Route as AuthenticatedInvoicesRouteImport } from './routes/_authenticated/invoices'
import { Route as AuthenticatedImportantDocumentsRouteImport } from './routes/_authenticated/important-documents'
import { Route as AuthenticatedGoogleDriveConfigRouteImport } from './routes/_authenticated/google-drive-config'
import { Route as AuthenticatedGoogleDocsConfigRouteImport } from './routes/_authenticated/google-docs-config'
import { Route as AuthenticatedGeminiConfigRouteImport } from './routes/_authenticated/gemini-config'
import { Route as AuthenticatedExternalIntegrationsRouteImport } from './routes/_authenticated/external-integrations'
import { Route as AuthenticatedEquipmentsRouteImport } from './routes/_authenticated/equipments'
import { Route as AuthenticatedDriveManagerRouteImport } from './routes/_authenticated/drive-manager'
import { Route as AuthenticatedDocumentsManagementRouteImport } from './routes/_authenticated/documents-management'
import { Route as AuthenticatedDocumentsAccessHistoryRouteImport } from './routes/_authenticated/documents-access-history'
import { Route as AuthenticatedDesktopVersionsRouteImport } from './routes/_authenticated/desktop-versions'
import { Route as AuthenticatedContractManagementRouteImport } from './routes/_authenticated/contract-management'
import { Route as AuthenticatedCompanyDocumentsRouteImport } from './routes/_authenticated/company-documents'
import { Route as AuthenticatedCnpjSearchRouteImport } from './routes/_authenticated/cnpj-search'
import { Route as AuthenticatedCategoriesRouteImport } from './routes/_authenticated/categories'
import { Route as AuthenticatedCalendarConfigRouteImport } from './routes/_authenticated/calendar-config'
import { Route as AuthenticatedCalendarCaptationsRouteImport } from './routes/_authenticated/calendar-captations'
import { Route as AuthenticatedCalendarCaptationApprovalsRouteImport } from './routes/_authenticated/calendar-captation-approvals'
import { Route as AuthenticatedCalendarRouteImport } from './routes/_authenticated/calendar'
import { Route as AuthenticatedAssetsRouteImport } from './routes/_authenticated/assets'
import { Route as AuthenticatedAssetKitsRouteImport } from './routes/_authenticated/asset-kits'
import { Route as AuthenticatedAdminTasksBoardRouteImport } from './routes/_authenticated/admin-tasks-board'
import { Route as AuthenticatedAdminDashboardRouteImport } from './routes/_authenticated/admin-dashboard'
import { Route as AuthenticatedTechSystemsIndexRouteImport } from './routes/_authenticated/tech-systems/index'
import { Route as AuthenticatedPlaybooksIndexRouteImport } from './routes/_authenticated/playbooks/index'
import { Route as AuthenticatedPipelineIndexRouteImport } from './routes/_authenticated/pipeline/index'
import { Route as AuthenticatedMyClientsIndexRouteImport } from './routes/_authenticated/my-clients/index'
import { Route as AuthenticatedEmployeesIndexRouteImport } from './routes/_authenticated/employees/index'
import { Route as AuthenticatedContractsIndexRouteImport } from './routes/_authenticated/contracts/index'
import { Route as AuthenticatedContractManagementIndexRouteImport } from './routes/_authenticated/contract-management.index'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedClientsIndexRouteImport } from './routes/_authenticated/clients/index'
import { Route as AuthenticatedClientInvoicesIndexRouteImport } from './routes/_authenticated/client-invoices/index'
import { Route as AuthenticatedClientContractsIndexRouteImport } from './routes/_authenticated/client-contracts/index'
import { Route as AuthenticatedCertificationIndexRouteImport } from './routes/_authenticated/certification/index'
import { Route as AuthenticatedAiAnalysisIndexRouteImport } from './routes/_authenticated/ai-analysis/index'
import { Route as InviteCodeTenantIdRouteImport } from './routes/invite.$code.$tenantId'
import { Route as AuthenticatedTechSystemsConfigRouteImport } from './routes/_authenticated/tech-systems/config'
import { Route as AuthenticatedTechSystemsIdRouteImport } from './routes/_authenticated/tech-systems/$id'
import { Route as AuthenticatedRemoteAccessDeviceIdRouteImport } from './routes/_authenticated/remote-access.$deviceId'
import { Route as AuthenticatedReimbursementsMyRequestsRouteImport } from './routes/_authenticated/reimbursements/my-requests'
import { Route as AuthenticatedReimbursementsAnalyticsRouteImport } from './routes/_authenticated/reimbursements/analytics'
import { Route as AuthenticatedReimbursementsAdminRouteImport } from './routes/_authenticated/reimbursements/admin'
import { Route as AuthenticatedPlaybooksTriggersRouteImport } from './routes/_authenticated/playbooks/triggers'
import { Route as AuthenticatedPlaybooksTemplatesRouteImport } from './routes/_authenticated/playbooks/templates'
import { Route as AuthenticatedPlaybooksNewRouteImport } from './routes/_authenticated/playbooks/new'
import { Route as AuthenticatedPlaybooksMyStepsRouteImport } from './routes/_authenticated/playbooks/my-steps'
import { Route as AuthenticatedPlaybooksConfigRouteImport } from './routes/_authenticated/playbooks/config'
import { Route as AuthenticatedPlaybooksIdRouteImport } from './routes/_authenticated/playbooks/$id'
import { Route as AuthenticatedPipelineKanbanRouteImport } from './routes/_authenticated/pipeline/kanban'
import { Route as AuthenticatedMyClientsIdRouteImport } from './routes/_authenticated/my-clients/$id'
import { Route as AuthenticatedMcpAuthorizeRouteImport } from './routes/_authenticated/mcp/authorize'
import { Route as AuthenticatedMattermostScheduledMessagesNewRouteImport } from './routes/_authenticated/mattermost-scheduled-messages/new'
import { Route as AuthenticatedEmployeesRecessControlRouteImport } from './routes/_authenticated/employees/recess-control'
import { Route as AuthenticatedEmployeesPaymentsRouteImport } from './routes/_authenticated/employees/payments'
import { Route as AuthenticatedEmployeesLogsRouteImport } from './routes/_authenticated/employees/logs'
import { Route as AuthenticatedEmployeesIdRouteImport } from './routes/_authenticated/employees/$id'
import { Route as AuthenticatedContractsSettingsRouteImport } from './routes/_authenticated/contracts/settings'
import { Route as AuthenticatedContractsLogsRouteImport } from './routes/_authenticated/contracts/logs'
import { Route as AuthenticatedCompaniesIdRouteImport } from './routes/_authenticated/companies/$id'
import { Route as AuthenticatedClientsBoardRouteImport } from './routes/_authenticated/clients/board'
import { Route as AuthenticatedClientsIdRouteImport } from './routes/_authenticated/clients/$id'
import { Route as AuthenticatedClientContractsSettingsRouteImport } from './routes/_authenticated/client-contracts/settings'
import { Route as AuthenticatedClientContractsHistoryRouteImport } from './routes/_authenticated/client-contracts/history'
import { Route as AuthenticatedAiAnalysisSettingsRouteImport } from './routes/_authenticated/ai-analysis/settings'
import { Route as AuthenticatedAiAnalysisAgentsRouteImport } from './routes/_authenticated/ai-analysis/agents'
import { Route as AuthenticatedAdminSystemTenantsRouteImport } from './routes/_authenticated/admin/system-tenants'
import { Route as AuthenticatedAdminSubscriptionRouteImport } from './routes/_authenticated/admin/subscription'
import { Route as AuthenticatedAdminStoreRouteImport } from './routes/_authenticated/admin/store'
import { Route as AuthenticatedAdminRecurringClientTasksRouteImport } from './routes/_authenticated/admin/recurring-client-tasks'
import { Route as AuthenticatedAdminPlansRouteImport } from './routes/_authenticated/admin/plans'
import { Route as AuthenticatedAdminOfficeRouteImport } from './routes/_authenticated/admin/office'
import { Route as AuthenticatedAdminNotionConfigRouteImport } from './routes/_authenticated/admin/notion-config'
import { Route as AuthenticatedAdminMcpRouteImport } from './routes/_authenticated/admin/mcp'
import { Route as AuthenticatedAdminGamificationEventsRouteImport } from './routes/_authenticated/admin/gamification-events'
import { Route as AuthenticatedAdminFeaturesRouteImport } from './routes/_authenticated/admin/features'
import { Route as AuthenticatedAdminClientsConfigRouteImport } from './routes/_authenticated/admin/clients-config'
import { Route as AuthenticatedAdminBrandingRouteImport } from './routes/_authenticated/admin/branding'
import { Route as AuthenticatedAdminAiCreditsRouteImport } from './routes/_authenticated/admin/ai-credits'
import { Route as AuthenticatedTechSystemsTicketsIndexRouteImport } from './routes/_authenticated/tech-systems/tickets/index'
import { Route as AuthenticatedTechSystemsTemplatesIndexRouteImport } from './routes/_authenticated/tech-systems/templates/index'
import { Route as AuthenticatedTechSystemsProjectsIndexRouteImport } from './routes/_authenticated/tech-systems/projects/index'
import { Route as AuthenticatedPipelineLeadsIndexRouteImport } from './routes/_authenticated/pipeline/leads.index'
import { Route as AuthenticatedPipelineAssetsIndexRouteImport } from './routes/_authenticated/pipeline/assets.index'
import { Route as AuthenticatedCertificationManageIndexRouteImport } from './routes/_authenticated/certification/manage/index'
import { Route as AuthenticatedAdminInvoicesIndexRouteImport } from './routes/_authenticated/admin/invoices/index'
import { Route as AuthenticatedTechSystemsTicketsFinanceRouteImport } from './routes/_authenticated/tech-systems/tickets/finance'
import { Route as AuthenticatedTechSystemsTicketsTicketIdRouteImport } from './routes/_authenticated/tech-systems/tickets/$ticketId'
import { Route as AuthenticatedTechSystemsTemplatesIdRouteImport } from './routes/_authenticated/tech-systems/templates/$id'
import { Route as AuthenticatedTechSystemsProjectsIdRouteImport } from './routes/_authenticated/tech-systems/projects/$id'
import { Route as AuthenticatedPlaybooksTasksMineRouteImport } from './routes/_authenticated/playbooks/tasks/mine'
import { Route as AuthenticatedPipelineLeadsNovoRouteImport } from './routes/_authenticated/pipeline/leads.novo'
import { Route as AuthenticatedPipelineLeadsIdRouteImport } from './routes/_authenticated/pipeline/leads.$id'
import { Route as AuthenticatedPipelineAssetsNovoRouteImport } from './routes/_authenticated/pipeline/assets.novo'
import { Route as AuthenticatedPipelineAssetsIdRouteImport } from './routes/_authenticated/pipeline/assets.$id'
import { Route as AuthenticatedContractManagementTemplatesNewRouteImport } from './routes/_authenticated/contract-management.templates.new'
import { Route as AuthenticatedContractManagementTemplatesIdRouteImport } from './routes/_authenticated/contract-management.templates.$id'
import { Route as AuthenticatedContractManagementContractsIdRouteImport } from './routes/_authenticated/contract-management.contracts.$id'
import { Route as AuthenticatedCertificationCoursesCourseIdRouteImport } from './routes/_authenticated/certification/courses/$courseId'
import { Route as AuthenticatedCertificationCertificadosCertificateIdRouteImport } from './routes/_authenticated/certification/certificados/$certificateId'
import { Route as AuthenticatedAdminInvoicesMissingRouteImport } from './routes/_authenticated/admin/invoices/missing'
import { Route as AuthenticatedAdminInvoicesSubmittedIndexRouteImport } from './routes/_authenticated/admin/invoices/submitted/index'
import { Route as AuthenticatedCertificationCoursesCourseIdSimuladoRouteImport } from './routes/_authenticated/certification/courses/$courseId/simulado'
import { Route as AuthenticatedAdminInvoicesSubmittedUserIdRouteImport } from './routes/_authenticated/admin/invoices/submitted/$userId'

const TermosDeUsoRoute = TermosDeUsoRouteImport.update({
  id: '/termos-de-uso',
  path: '/termos-de-uso',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemLoginRoute = SystemLoginRouteImport.update({
  id: '/system-login',
  path: '/system-login',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoRoute = SsoRouteImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliticaPrivacidadeRoute = PoliticaPrivacidadeRouteImport.update({
  id: '/politica-privacidade',
  path: '/politica-privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliticaCookieRoute = PoliticaCookieRouteImport.update({
  id: '/politica-cookie',
  path: '/politica-cookie',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const GoogleDriveOauthCallbackRoute =
  GoogleDriveOauthCallbackRouteImport.update({
    id: '/google-drive-oauth-callback',
    path: '/google-drive-oauth-callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ExclusaoDeDadosRoute = ExclusaoDeDadosRouteImport.update({
  id: '/exclusao-de-dados',
  path: '/exclusao-de-dados',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarOauthCallbackRoute = CalendarOauthCallbackRouteImport.update({
  id: '/calendar-oauth-callback',
  path: '/calendar-oauth-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemRouteRoute = SystemRouteRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemIndexRoute = SystemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SystemRouteRoute,
} as any)
const SystemUsersRoute = SystemUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SystemRouteRoute,
} as any)
const SystemTenantsRoute = SystemTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => SystemRouteRoute,
} as any)
const SystemTenantUsageRoute = SystemTenantUsageRouteImport.update({
  id: '/tenant-usage',
  path: '/tenant-usage',
  getParentRoute: () => SystemRouteRoute,
} as any)
const SystemSupportRoute = SystemSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => SystemRouteRoute,
} as any)
const SystemSettingsRoute = SystemSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => SystemRouteRoute,
} as any)
const SystemPlansRoute = SystemPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => SystemRouteRoute,
} as any)
const SystemLogsRoute = SystemLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => SystemRouteRoute,
} as any)
const SystemDevicesRoute = SystemDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => SystemRouteRoute,
} as any)
const SystemAiCreditPackagesRoute = SystemAiCreditPackagesRouteImport.update({
  id: '/ai-credit-packages',
  path: '/ai-credit-packages',
  getParentRoute: () => SystemRouteRoute,
} as any)
const AuthenticatedWhatsappConfigRoute =
  AuthenticatedWhatsappConfigRouteImport.update({
    id: '/whatsapp-config',
    path: '/whatsapp-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersBirthdaysRoute =
  AuthenticatedUsersBirthdaysRouteImport.update({
    id: '/users-birthdays',
    path: '/users-birthdays',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTeamsRoute = AuthenticatedTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTeamCalendarRoute =
  AuthenticatedTeamCalendarRouteImport.update({
    id: '/team-calendar',
    path: '/team-calendar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksHistoryRoute =
  AuthenticatedTasksHistoryRouteImport.update({
    id: '/tasks-history',
    path: '/tasks-history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksBoardRoute = AuthenticatedTasksBoardRouteImport.update({
  id: '/tasks-board',
  path: '/tasks-board',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTaskPlanningCalendarRoute =
  AuthenticatedTaskPlanningCalendarRouteImport.update({
    id: '/task-planning-calendar',
    path: '/task-planning-calendar',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTaskManagementRoute =
  AuthenticatedTaskManagementRouteImport.update({
    id: '/task-management',
    path: '/task-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStoreRoute = AuthenticatedStoreRouteImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRolesRoute = AuthenticatedRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRequestsRoute = AuthenticatedRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRemoteCommandsRoute =
  AuthenticatedRemoteCommandsRouteImport.update({
    id: '/remote-commands',
    path: '/remote-commands',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRealtimeRoute = AuthenticatedRealtimeRouteImport.update({
  id: '/realtime',
  path: '/realtime',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPointsDashboardRoute =
  AuthenticatedPointsDashboardRouteImport.update({
    id: '/points-dashboard',
    path: '/points-dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPasswordsRoute = AuthenticatedPasswordsRouteImport.update({
  id: '/passwords',
  path: '/passwords',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOmnichannelTwilioConfigRoute =
  AuthenticatedOmnichannelTwilioConfigRouteImport.update({
    id: '/omnichannel-twilio-config',
    path: '/omnichannel-twilio-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOmnichannelTwilioRoute =
  AuthenticatedOmnichannelTwilioRouteImport.update({
    id: '/omnichannel-twilio',
    path: '/omnichannel-twilio',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOfficeCalendarConfigRoute =
  AuthenticatedOfficeCalendarConfigRouteImport.update({
    id: '/office-calendar-config',
    path: '/office-calendar-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotebookRoute = AuthenticatedNotebookRouteImport.update({
  id: '/notebook',
  path: '/notebook',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMyRequestsRoute = AuthenticatedMyRequestsRouteImport.update({
  id: '/my-requests',
  path: '/my-requests',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMyPasswordsRoute =
  AuthenticatedMyPasswordsRouteImport.update({
    id: '/my-passwords',
    path: '/my-passwords',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyDashboardRoute =
  AuthenticatedMyDashboardRouteImport.update({
    id: '/my-dashboard',
    path: '/my-dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMinhaEmpresaRoute =
  AuthenticatedMinhaEmpresaRouteImport.update({
    id: '/minha-empresa',
    path: '/minha-empresa',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMindmapsRoute = AuthenticatedMindmapsRouteImport.update({
  id: '/mindmaps',
  path: '/mindmaps',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMetaOmnichannelConfigRoute =
  AuthenticatedMetaOmnichannelConfigRouteImport.update({
    id: '/meta-omnichannel-config',
    path: '/meta-omnichannel-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMetaOmnichannelRoute =
  AuthenticatedMetaOmnichannelRouteImport.update({
    id: '/meta-omnichannel',
    path: '/meta-omnichannel',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMattermostSyncChannelsRoute =
  AuthenticatedMattermostSyncChannelsRouteImport.update({
    id: '/mattermost-sync-channels',
    path: '/mattermost-sync-channels',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMattermostScheduledMessagesRoute =
  AuthenticatedMattermostScheduledMessagesRouteImport.update({
    id: '/mattermost-scheduled-messages',
    path: '/mattermost-scheduled-messages',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMattermostImageValidationRoute =
  AuthenticatedMattermostImageValidationRouteImport.update({
    id: '/mattermost-image-validation',
    path: '/mattermost-image-validation',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMattermostConfigRoute =
  AuthenticatedMattermostConfigRouteImport.update({
    id: '/mattermost-config',
    path: '/mattermost-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKanbanRoute = AuthenticatedKanbanRouteImport.update({
  id: '/kanban',
  path: '/kanban',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInvoicesRoute = AuthenticatedInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedImportantDocumentsRoute =
  AuthenticatedImportantDocumentsRouteImport.update({
    id: '/important-documents',
    path: '/important-documents',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGoogleDriveConfigRoute =
  AuthenticatedGoogleDriveConfigRouteImport.update({
    id: '/google-drive-config',
    path: '/google-drive-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGoogleDocsConfigRoute =
  AuthenticatedGoogleDocsConfigRouteImport.update({
    id: '/google-docs-config',
    path: '/google-docs-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGeminiConfigRoute =
  AuthenticatedGeminiConfigRouteImport.update({
    id: '/gemini-config',
    path: '/gemini-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExternalIntegrationsRoute =
  AuthenticatedExternalIntegrationsRouteImport.update({
    id: '/external-integrations',
    path: '/external-integrations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEquipmentsRoute = AuthenticatedEquipmentsRouteImport.update({
  id: '/equipments',
  path: '/equipments',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDriveManagerRoute =
  AuthenticatedDriveManagerRouteImport.update({
    id: '/drive-manager',
    path: '/drive-manager',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocumentsManagementRoute =
  AuthenticatedDocumentsManagementRouteImport.update({
    id: '/documents-management',
    path: '/documents-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDocumentsAccessHistoryRoute =
  AuthenticatedDocumentsAccessHistoryRouteImport.update({
    id: '/documents-access-history',
    path: '/documents-access-history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDesktopVersionsRoute =
  AuthenticatedDesktopVersionsRouteImport.update({
    id: '/desktop-versions',
    path: '/desktop-versions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractManagementRoute =
  AuthenticatedContractManagementRouteImport.update({
    id: '/contract-management',
    path: '/contract-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompanyDocumentsRoute =
  AuthenticatedCompanyDocumentsRouteImport.update({
    id: '/company-documents',
    path: '/company-documents',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCnpjSearchRoute = AuthenticatedCnpjSearchRouteImport.update({
  id: '/cnpj-search',
  path: '/cnpj-search',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCategoriesRoute = AuthenticatedCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCalendarConfigRoute =
  AuthenticatedCalendarConfigRouteImport.update({
    id: '/calendar-config',
    path: '/calendar-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarCaptationsRoute =
  AuthenticatedCalendarCaptationsRouteImport.update({
    id: '/calendar-captations',
    path: '/calendar-captations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarCaptationApprovalsRoute =
  AuthenticatedCalendarCaptationApprovalsRouteImport.update({
    id: '/calendar-captation-approvals',
    path: '/calendar-captation-approvals',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalendarRoute = AuthenticatedCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAssetsRoute = AuthenticatedAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAssetKitsRoute = AuthenticatedAssetKitsRouteImport.update({
  id: '/asset-kits',
  path: '/asset-kits',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminTasksBoardRoute =
  AuthenticatedAdminTasksBoardRouteImport.update({
    id: '/admin-tasks-board',
    path: '/admin-tasks-board',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminDashboardRoute =
  AuthenticatedAdminDashboardRouteImport.update({
    id: '/admin-dashboard',
    path: '/admin-dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTechSystemsIndexRoute =
  AuthenticatedTechSystemsIndexRouteImport.update({
    id: '/tech-systems/',
    path: '/tech-systems/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlaybooksIndexRoute =
  AuthenticatedPlaybooksIndexRouteImport.update({
    id: '/playbooks/',
    path: '/playbooks/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPipelineIndexRoute =
  AuthenticatedPipelineIndexRouteImport.update({
    id: '/pipeline/',
    path: '/pipeline/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyClientsIndexRoute =
  AuthenticatedMyClientsIndexRouteImport.update({
    id: '/my-clients/',
    path: '/my-clients/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmployeesIndexRoute =
  AuthenticatedEmployeesIndexRouteImport.update({
    id: '/employees/',
    path: '/employees/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsIndexRoute =
  AuthenticatedContractsIndexRouteImport.update({
    id: '/contracts/',
    path: '/contracts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractManagementIndexRoute =
  AuthenticatedContractManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedContractManagementRoute,
  } as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsIndexRoute =
  AuthenticatedClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientInvoicesIndexRoute =
  AuthenticatedClientInvoicesIndexRouteImport.update({
    id: '/client-invoices/',
    path: '/client-invoices/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientContractsIndexRoute =
  AuthenticatedClientContractsIndexRouteImport.update({
    id: '/client-contracts/',
    path: '/client-contracts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCertificationIndexRoute =
  AuthenticatedCertificationIndexRouteImport.update({
    id: '/certification/',
    path: '/certification/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiAnalysisIndexRoute =
  AuthenticatedAiAnalysisIndexRouteImport.update({
    id: '/ai-analysis/',
    path: '/ai-analysis/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const InviteCodeTenantIdRoute = InviteCodeTenantIdRouteImport.update({
  id: '/invite/$code/$tenantId',
  path: '/invite/$code/$tenantId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTechSystemsConfigRoute =
  AuthenticatedTechSystemsConfigRouteImport.update({
    id: '/tech-systems/config',
    path: '/tech-systems/config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTechSystemsIdRoute =
  AuthenticatedTechSystemsIdRouteImport.update({
    id: '/tech-systems/$id',
    path: '/tech-systems/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRemoteAccessDeviceIdRoute =
  AuthenticatedRemoteAccessDeviceIdRouteImport.update({
    id: '/remote-access/$deviceId',
    path: '/remote-access/$deviceId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReimbursementsMyRequestsRoute =
  AuthenticatedReimbursementsMyRequestsRouteImport.update({
    id: '/reimbursements/my-requests',
    path: '/reimbursements/my-requests',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReimbursementsAnalyticsRoute =
  AuthenticatedReimbursementsAnalyticsRouteImport.update({
    id: '/reimbursements/analytics',
    path: '/reimbursements/analytics',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReimbursementsAdminRoute =
  AuthenticatedReimbursementsAdminRouteImport.update({
    id: '/reimbursements/admin',
    path: '/reimbursements/admin',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlaybooksTriggersRoute =
  AuthenticatedPlaybooksTriggersRouteImport.update({
    id: '/playbooks/triggers',
    path: '/playbooks/triggers',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlaybooksTemplatesRoute =
  AuthenticatedPlaybooksTemplatesRouteImport.update({
    id: '/playbooks/templates',
    path: '/playbooks/templates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlaybooksNewRoute =
  AuthenticatedPlaybooksNewRouteImport.update({
    id: '/playbooks/new',
    path: '/playbooks/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlaybooksMyStepsRoute =
  AuthenticatedPlaybooksMyStepsRouteImport.update({
    id: '/playbooks/my-steps',
    path: '/playbooks/my-steps',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlaybooksConfigRoute =
  AuthenticatedPlaybooksConfigRouteImport.update({
    id: '/playbooks/config',
    path: '/playbooks/config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlaybooksIdRoute =
  AuthenticatedPlaybooksIdRouteImport.update({
    id: '/playbooks/$id',
    path: '/playbooks/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPipelineKanbanRoute =
  AuthenticatedPipelineKanbanRouteImport.update({
    id: '/pipeline/kanban',
    path: '/pipeline/kanban',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyClientsIdRoute =
  AuthenticatedMyClientsIdRouteImport.update({
    id: '/my-clients/$id',
    path: '/my-clients/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMcpAuthorizeRoute =
  AuthenticatedMcpAuthorizeRouteImport.update({
    id: '/mcp/authorize',
    path: '/mcp/authorize',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMattermostScheduledMessagesNewRoute =
  AuthenticatedMattermostScheduledMessagesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedMattermostScheduledMessagesRoute,
  } as any)
const AuthenticatedEmployeesRecessControlRoute =
  AuthenticatedEmployeesRecessControlRouteImport.update({
    id: '/employees/recess-control',
    path: '/employees/recess-control',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmployeesPaymentsRoute =
  AuthenticatedEmployeesPaymentsRouteImport.update({
    id: '/employees/payments',
    path: '/employees/payments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmployeesLogsRoute =
  AuthenticatedEmployeesLogsRouteImport.update({
    id: '/employees/logs',
    path: '/employees/logs',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmployeesIdRoute =
  AuthenticatedEmployeesIdRouteImport.update({
    id: '/employees/$id',
    path: '/employees/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsSettingsRoute =
  AuthenticatedContractsSettingsRouteImport.update({
    id: '/contracts/settings',
    path: '/contracts/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractsLogsRoute =
  AuthenticatedContractsLogsRouteImport.update({
    id: '/contracts/logs',
    path: '/contracts/logs',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesIdRoute =
  AuthenticatedCompaniesIdRouteImport.update({
    id: '/companies/$id',
    path: '/companies/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsBoardRoute =
  AuthenticatedClientsBoardRouteImport.update({
    id: '/clients/board',
    path: '/clients/board',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsIdRoute = AuthenticatedClientsIdRouteImport.update({
  id: '/clients/$id',
  path: '/clients/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClientContractsSettingsRoute =
  AuthenticatedClientContractsSettingsRouteImport.update({
    id: '/client-contracts/settings',
    path: '/client-contracts/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientContractsHistoryRoute =
  AuthenticatedClientContractsHistoryRouteImport.update({
    id: '/client-contracts/history',
    path: '/client-contracts/history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiAnalysisSettingsRoute =
  AuthenticatedAiAnalysisSettingsRouteImport.update({
    id: '/ai-analysis/settings',
    path: '/ai-analysis/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAiAnalysisAgentsRoute =
  AuthenticatedAiAnalysisAgentsRouteImport.update({
    id: '/ai-analysis/agents',
    path: '/ai-analysis/agents',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminSystemTenantsRoute =
  AuthenticatedAdminSystemTenantsRouteImport.update({
    id: '/admin/system-tenants',
    path: '/admin/system-tenants',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminSubscriptionRoute =
  AuthenticatedAdminSubscriptionRouteImport.update({
    id: '/admin/subscription',
    path: '/admin/subscription',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminStoreRoute = AuthenticatedAdminStoreRouteImport.update({
  id: '/admin/store',
  path: '/admin/store',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRecurringClientTasksRoute =
  AuthenticatedAdminRecurringClientTasksRouteImport.update({
    id: '/admin/recurring-client-tasks',
    path: '/admin/recurring-client-tasks',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminPlansRoute = AuthenticatedAdminPlansRouteImport.update({
  id: '/admin/plans',
  path: '/admin/plans',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminOfficeRoute =
  AuthenticatedAdminOfficeRouteImport.update({
    id: '/admin/office',
    path: '/admin/office',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminNotionConfigRoute =
  AuthenticatedAdminNotionConfigRouteImport.update({
    id: '/admin/notion-config',
    path: '/admin/notion-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminMcpRoute = AuthenticatedAdminMcpRouteImport.update({
  id: '/admin/mcp',
  path: '/admin/mcp',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminGamificationEventsRoute =
  AuthenticatedAdminGamificationEventsRouteImport.update({
    id: '/admin/gamification-events',
    path: '/admin/gamification-events',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminFeaturesRoute =
  AuthenticatedAdminFeaturesRouteImport.update({
    id: '/admin/features',
    path: '/admin/features',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminClientsConfigRoute =
  AuthenticatedAdminClientsConfigRouteImport.update({
    id: '/admin/clients-config',
    path: '/admin/clients-config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminBrandingRoute =
  AuthenticatedAdminBrandingRouteImport.update({
    id: '/admin/branding',
    path: '/admin/branding',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminAiCreditsRoute =
  AuthenticatedAdminAiCreditsRouteImport.update({
    id: '/admin/ai-credits',
    path: '/admin/ai-credits',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTechSystemsTicketsIndexRoute =
  AuthenticatedTechSystemsTicketsIndexRouteImport.update({
    id: '/tech-systems/tickets/',
    path: '/tech-systems/tickets/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTechSystemsTemplatesIndexRoute =
  AuthenticatedTechSystemsTemplatesIndexRouteImport.update({
    id: '/tech-systems/templates/',
    path: '/tech-systems/templates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTechSystemsProjectsIndexRoute =
  AuthenticatedTechSystemsProjectsIndexRouteImport.update({
    id: '/tech-systems/projects/',
    path: '/tech-systems/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPipelineLeadsIndexRoute =
  AuthenticatedPipelineLeadsIndexRouteImport.update({
    id: '/pipeline/leads/',
    path: '/pipeline/leads/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPipelineAssetsIndexRoute =
  AuthenticatedPipelineAssetsIndexRouteImport.update({
    id: '/pipeline/assets/',
    path: '/pipeline/assets/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCertificationManageIndexRoute =
  AuthenticatedCertificationManageIndexRouteImport.update({
    id: '/certification/manage/',
    path: '/certification/manage/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminInvoicesIndexRoute =
  AuthenticatedAdminInvoicesIndexRouteImport.update({
    id: '/admin/invoices/',
    path: '/admin/invoices/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTechSystemsTicketsFinanceRoute =
  AuthenticatedTechSystemsTicketsFinanceRouteImport.update({
    id: '/tech-systems/tickets/finance',
    path: '/tech-systems/tickets/finance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTechSystemsTicketsTicketIdRoute =
  AuthenticatedTechSystemsTicketsTicketIdRouteImport.update({
    id: '/tech-systems/tickets/$ticketId',
    path: '/tech-systems/tickets/$ticketId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTechSystemsTemplatesIdRoute =
  AuthenticatedTechSystemsTemplatesIdRouteImport.update({
    id: '/tech-systems/templates/$id',
    path: '/tech-systems/templates/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTechSystemsProjectsIdRoute =
  AuthenticatedTechSystemsProjectsIdRouteImport.update({
    id: '/tech-systems/projects/$id',
    path: '/tech-systems/projects/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPlaybooksTasksMineRoute =
  AuthenticatedPlaybooksTasksMineRouteImport.update({
    id: '/playbooks/tasks/mine',
    path: '/playbooks/tasks/mine',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPipelineLeadsNovoRoute =
  AuthenticatedPipelineLeadsNovoRouteImport.update({
    id: '/pipeline/leads/novo',
    path: '/pipeline/leads/novo',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPipelineLeadsIdRoute =
  AuthenticatedPipelineLeadsIdRouteImport.update({
    id: '/pipeline/leads/$id',
    path: '/pipeline/leads/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPipelineAssetsNovoRoute =
  AuthenticatedPipelineAssetsNovoRouteImport.update({
    id: '/pipeline/assets/novo',
    path: '/pipeline/assets/novo',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPipelineAssetsIdRoute =
  AuthenticatedPipelineAssetsIdRouteImport.update({
    id: '/pipeline/assets/$id',
    path: '/pipeline/assets/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedContractManagementTemplatesNewRoute =
  AuthenticatedContractManagementTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => AuthenticatedContractManagementRoute,
  } as any)
const AuthenticatedContractManagementTemplatesIdRoute =
  AuthenticatedContractManagementTemplatesIdRouteImport.update({
    id: '/templates/$id',
    path: '/templates/$id',
    getParentRoute: () => AuthenticatedContractManagementRoute,
  } as any)
const AuthenticatedContractManagementContractsIdRoute =
  AuthenticatedContractManagementContractsIdRouteImport.update({
    id: '/contracts/$id',
    path: '/contracts/$id',
    getParentRoute: () => AuthenticatedContractManagementRoute,
  } as any)
const AuthenticatedCertificationCoursesCourseIdRoute =
  AuthenticatedCertificationCoursesCourseIdRouteImport.update({
    id: '/certification/courses/$courseId',
    path: '/certification/courses/$courseId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCertificationCertificadosCertificateIdRoute =
  AuthenticatedCertificationCertificadosCertificateIdRouteImport.update({
    id: '/certification/certificados/$certificateId',
    path: '/certification/certificados/$certificateId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminInvoicesMissingRoute =
  AuthenticatedAdminInvoicesMissingRouteImport.update({
    id: '/admin/invoices/missing',
    path: '/admin/invoices/missing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminInvoicesSubmittedIndexRoute =
  AuthenticatedAdminInvoicesSubmittedIndexRouteImport.update({
    id: '/admin/invoices/submitted/',
    path: '/admin/invoices/submitted/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCertificationCoursesCourseIdSimuladoRoute =
  AuthenticatedCertificationCoursesCourseIdSimuladoRouteImport.update({
    id: '/simulado',
    path: '/simulado',
    getParentRoute: () => AuthenticatedCertificationCoursesCourseIdRoute,
  } as any)
const AuthenticatedAdminInvoicesSubmittedUserIdRoute =
  AuthenticatedAdminInvoicesSubmittedUserIdRouteImport.update({
    id: '/admin/invoices/submitted/$userId',
    path: '/admin/invoices/submitted/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/system': typeof SystemRouteRouteWithChildren
  '/calendar-oauth-callback': typeof CalendarOauthCallbackRoute
  '/exclusao-de-dados': typeof ExclusaoDeDadosRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/google-drive-oauth-callback': typeof GoogleDriveOauthCallbackRoute
  '/login': typeof LoginRoute
  '/politica-cookie': typeof PoliticaCookieRoute
  '/politica-privacidade': typeof PoliticaPrivacidadeRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sso': typeof SsoRoute
  '/system-login': typeof SystemLoginRoute
  '/termos-de-uso': typeof TermosDeUsoRoute
  '/admin-dashboard': typeof AuthenticatedAdminDashboardRoute
  '/admin-tasks-board': typeof AuthenticatedAdminTasksBoardRoute
  '/asset-kits': typeof AuthenticatedAssetKitsRoute
  '/assets': typeof AuthenticatedAssetsRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/calendar-captation-approvals': typeof AuthenticatedCalendarCaptationApprovalsRoute
  '/calendar-captations': typeof AuthenticatedCalendarCaptationsRoute
  '/calendar-config': typeof AuthenticatedCalendarConfigRoute
  '/categories': typeof AuthenticatedCategoriesRoute
  '/cnpj-search': typeof AuthenticatedCnpjSearchRoute
  '/company-documents': typeof AuthenticatedCompanyDocumentsRoute
  '/contract-management': typeof AuthenticatedContractManagementRouteWithChildren
  '/desktop-versions': typeof AuthenticatedDesktopVersionsRoute
  '/documents-access-history': typeof AuthenticatedDocumentsAccessHistoryRoute
  '/documents-management': typeof AuthenticatedDocumentsManagementRoute
  '/drive-manager': typeof AuthenticatedDriveManagerRoute
  '/equipments': typeof AuthenticatedEquipmentsRoute
  '/external-integrations': typeof AuthenticatedExternalIntegrationsRoute
  '/gemini-config': typeof AuthenticatedGeminiConfigRoute
  '/google-docs-config': typeof AuthenticatedGoogleDocsConfigRoute
  '/google-drive-config': typeof AuthenticatedGoogleDriveConfigRoute
  '/important-documents': typeof AuthenticatedImportantDocumentsRoute
  '/invoices': typeof AuthenticatedInvoicesRoute
  '/kanban': typeof AuthenticatedKanbanRoute
  '/mattermost-config': typeof AuthenticatedMattermostConfigRoute
  '/mattermost-image-validation': typeof AuthenticatedMattermostImageValidationRoute
  '/mattermost-scheduled-messages': typeof AuthenticatedMattermostScheduledMessagesRouteWithChildren
  '/mattermost-sync-channels': typeof AuthenticatedMattermostSyncChannelsRoute
  '/meta-omnichannel': typeof AuthenticatedMetaOmnichannelRoute
  '/meta-omnichannel-config': typeof AuthenticatedMetaOmnichannelConfigRoute
  '/mindmaps': typeof AuthenticatedMindmapsRoute
  '/minha-empresa': typeof AuthenticatedMinhaEmpresaRoute
  '/my-dashboard': typeof AuthenticatedMyDashboardRoute
  '/my-passwords': typeof AuthenticatedMyPasswordsRoute
  '/my-requests': typeof AuthenticatedMyRequestsRoute
  '/notebook': typeof AuthenticatedNotebookRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/office-calendar-config': typeof AuthenticatedOfficeCalendarConfigRoute
  '/omnichannel-twilio': typeof AuthenticatedOmnichannelTwilioRoute
  '/omnichannel-twilio-config': typeof AuthenticatedOmnichannelTwilioConfigRoute
  '/passwords': typeof AuthenticatedPasswordsRoute
  '/points-dashboard': typeof AuthenticatedPointsDashboardRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/realtime': typeof AuthenticatedRealtimeRoute
  '/remote-commands': typeof AuthenticatedRemoteCommandsRoute
  '/requests': typeof AuthenticatedRequestsRoute
  '/roles': typeof AuthenticatedRolesRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/store': typeof AuthenticatedStoreRoute
  '/task-management': typeof AuthenticatedTaskManagementRoute
  '/task-planning-calendar': typeof AuthenticatedTaskPlanningCalendarRoute
  '/tasks-board': typeof AuthenticatedTasksBoardRoute
  '/tasks-history': typeof AuthenticatedTasksHistoryRoute
  '/team-calendar': typeof AuthenticatedTeamCalendarRoute
  '/teams': typeof AuthenticatedTeamsRoute
  '/users': typeof AuthenticatedUsersRoute
  '/users-birthdays': typeof AuthenticatedUsersBirthdaysRoute
  '/whatsapp-config': typeof AuthenticatedWhatsappConfigRoute
  '/system/ai-credit-packages': typeof SystemAiCreditPackagesRoute
  '/system/devices': typeof SystemDevicesRoute
  '/system/logs': typeof SystemLogsRoute
  '/system/plans': typeof SystemPlansRoute
  '/system/settings': typeof SystemSettingsRoute
  '/system/support': typeof SystemSupportRoute
  '/system/tenant-usage': typeof SystemTenantUsageRoute
  '/system/tenants': typeof SystemTenantsRoute
  '/system/users': typeof SystemUsersRoute
  '/system/': typeof SystemIndexRoute
  '/admin/ai-credits': typeof AuthenticatedAdminAiCreditsRoute
  '/admin/branding': typeof AuthenticatedAdminBrandingRoute
  '/admin/clients-config': typeof AuthenticatedAdminClientsConfigRoute
  '/admin/features': typeof AuthenticatedAdminFeaturesRoute
  '/admin/gamification-events': typeof AuthenticatedAdminGamificationEventsRoute
  '/admin/mcp': typeof AuthenticatedAdminMcpRoute
  '/admin/notion-config': typeof AuthenticatedAdminNotionConfigRoute
  '/admin/office': typeof AuthenticatedAdminOfficeRoute
  '/admin/plans': typeof AuthenticatedAdminPlansRoute
  '/admin/recurring-client-tasks': typeof AuthenticatedAdminRecurringClientTasksRoute
  '/admin/store': typeof AuthenticatedAdminStoreRoute
  '/admin/subscription': typeof AuthenticatedAdminSubscriptionRoute
  '/admin/system-tenants': typeof AuthenticatedAdminSystemTenantsRoute
  '/ai-analysis/agents': typeof AuthenticatedAiAnalysisAgentsRoute
  '/ai-analysis/settings': typeof AuthenticatedAiAnalysisSettingsRoute
  '/client-contracts/history': typeof AuthenticatedClientContractsHistoryRoute
  '/client-contracts/settings': typeof AuthenticatedClientContractsSettingsRoute
  '/clients/$id': typeof AuthenticatedClientsIdRoute
  '/clients/board': typeof AuthenticatedClientsBoardRoute
  '/companies/$id': typeof AuthenticatedCompaniesIdRoute
  '/contracts/logs': typeof AuthenticatedContractsLogsRoute
  '/contracts/settings': typeof AuthenticatedContractsSettingsRoute
  '/employees/$id': typeof AuthenticatedEmployeesIdRoute
  '/employees/logs': typeof AuthenticatedEmployeesLogsRoute
  '/employees/payments': typeof AuthenticatedEmployeesPaymentsRoute
  '/employees/recess-control': typeof AuthenticatedEmployeesRecessControlRoute
  '/mattermost-scheduled-messages/new': typeof AuthenticatedMattermostScheduledMessagesNewRoute
  '/mcp/authorize': typeof AuthenticatedMcpAuthorizeRoute
  '/my-clients/$id': typeof AuthenticatedMyClientsIdRoute
  '/pipeline/kanban': typeof AuthenticatedPipelineKanbanRoute
  '/playbooks/$id': typeof AuthenticatedPlaybooksIdRoute
  '/playbooks/config': typeof AuthenticatedPlaybooksConfigRoute
  '/playbooks/my-steps': typeof AuthenticatedPlaybooksMyStepsRoute
  '/playbooks/new': typeof AuthenticatedPlaybooksNewRoute
  '/playbooks/templates': typeof AuthenticatedPlaybooksTemplatesRoute
  '/playbooks/triggers': typeof AuthenticatedPlaybooksTriggersRoute
  '/reimbursements/admin': typeof AuthenticatedReimbursementsAdminRoute
  '/reimbursements/analytics': typeof AuthenticatedReimbursementsAnalyticsRoute
  '/reimbursements/my-requests': typeof AuthenticatedReimbursementsMyRequestsRoute
  '/remote-access/$deviceId': typeof AuthenticatedRemoteAccessDeviceIdRoute
  '/tech-systems/$id': typeof AuthenticatedTechSystemsIdRoute
  '/tech-systems/config': typeof AuthenticatedTechSystemsConfigRoute
  '/invite/$code/$tenantId': typeof InviteCodeTenantIdRoute
  '/ai-analysis/': typeof AuthenticatedAiAnalysisIndexRoute
  '/certification/': typeof AuthenticatedCertificationIndexRoute
  '/client-contracts/': typeof AuthenticatedClientContractsIndexRoute
  '/client-invoices/': typeof AuthenticatedClientInvoicesIndexRoute
  '/clients/': typeof AuthenticatedClientsIndexRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/contract-management/': typeof AuthenticatedContractManagementIndexRoute
  '/contracts/': typeof AuthenticatedContractsIndexRoute
  '/employees/': typeof AuthenticatedEmployeesIndexRoute
  '/my-clients/': typeof AuthenticatedMyClientsIndexRoute
  '/pipeline/': typeof AuthenticatedPipelineIndexRoute
  '/playbooks/': typeof AuthenticatedPlaybooksIndexRoute
  '/tech-systems/': typeof AuthenticatedTechSystemsIndexRoute
  '/admin/invoices/missing': typeof AuthenticatedAdminInvoicesMissingRoute
  '/certification/certificados/$certificateId': typeof AuthenticatedCertificationCertificadosCertificateIdRoute
  '/certification/courses/$courseId': typeof AuthenticatedCertificationCoursesCourseIdRouteWithChildren
  '/contract-management/contracts/$id': typeof AuthenticatedContractManagementContractsIdRoute
  '/contract-management/templates/$id': typeof AuthenticatedContractManagementTemplatesIdRoute
  '/contract-management/templates/new': typeof AuthenticatedContractManagementTemplatesNewRoute
  '/pipeline/assets/$id': typeof AuthenticatedPipelineAssetsIdRoute
  '/pipeline/assets/novo': typeof AuthenticatedPipelineAssetsNovoRoute
  '/pipeline/leads/$id': typeof AuthenticatedPipelineLeadsIdRoute
  '/pipeline/leads/novo': typeof AuthenticatedPipelineLeadsNovoRoute
  '/playbooks/tasks/mine': typeof AuthenticatedPlaybooksTasksMineRoute
  '/tech-systems/projects/$id': typeof AuthenticatedTechSystemsProjectsIdRoute
  '/tech-systems/templates/$id': typeof AuthenticatedTechSystemsTemplatesIdRoute
  '/tech-systems/tickets/$ticketId': typeof AuthenticatedTechSystemsTicketsTicketIdRoute
  '/tech-systems/tickets/finance': typeof AuthenticatedTechSystemsTicketsFinanceRoute
  '/admin/invoices/': typeof AuthenticatedAdminInvoicesIndexRoute
  '/certification/manage/': typeof AuthenticatedCertificationManageIndexRoute
  '/pipeline/assets/': typeof AuthenticatedPipelineAssetsIndexRoute
  '/pipeline/leads/': typeof AuthenticatedPipelineLeadsIndexRoute
  '/tech-systems/projects/': typeof AuthenticatedTechSystemsProjectsIndexRoute
  '/tech-systems/templates/': typeof AuthenticatedTechSystemsTemplatesIndexRoute
  '/tech-systems/tickets/': typeof AuthenticatedTechSystemsTicketsIndexRoute
  '/admin/invoices/submitted/$userId': typeof AuthenticatedAdminInvoicesSubmittedUserIdRoute
  '/certification/courses/$courseId/simulado': typeof AuthenticatedCertificationCoursesCourseIdSimuladoRoute
  '/admin/invoices/submitted/': typeof AuthenticatedAdminInvoicesSubmittedIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/calendar-oauth-callback': typeof CalendarOauthCallbackRoute
  '/exclusao-de-dados': typeof ExclusaoDeDadosRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/google-drive-oauth-callback': typeof GoogleDriveOauthCallbackRoute
  '/login': typeof LoginRoute
  '/politica-cookie': typeof PoliticaCookieRoute
  '/politica-privacidade': typeof PoliticaPrivacidadeRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sso': typeof SsoRoute
  '/system-login': typeof SystemLoginRoute
  '/termos-de-uso': typeof TermosDeUsoRoute
  '/admin-dashboard': typeof AuthenticatedAdminDashboardRoute
  '/admin-tasks-board': typeof AuthenticatedAdminTasksBoardRoute
  '/asset-kits': typeof AuthenticatedAssetKitsRoute
  '/assets': typeof AuthenticatedAssetsRoute
  '/calendar': typeof AuthenticatedCalendarRoute
  '/calendar-captation-approvals': typeof AuthenticatedCalendarCaptationApprovalsRoute
  '/calendar-captations': typeof AuthenticatedCalendarCaptationsRoute
  '/calendar-config': typeof AuthenticatedCalendarConfigRoute
  '/categories': typeof AuthenticatedCategoriesRoute
  '/cnpj-search': typeof AuthenticatedCnpjSearchRoute
  '/company-documents': typeof AuthenticatedCompanyDocumentsRoute
  '/desktop-versions': typeof AuthenticatedDesktopVersionsRoute
  '/documents-access-history': typeof AuthenticatedDocumentsAccessHistoryRoute
  '/documents-management': typeof AuthenticatedDocumentsManagementRoute
  '/drive-manager': typeof AuthenticatedDriveManagerRoute
  '/equipments': typeof AuthenticatedEquipmentsRoute
  '/external-integrations': typeof AuthenticatedExternalIntegrationsRoute
  '/gemini-config': typeof AuthenticatedGeminiConfigRoute
  '/google-docs-config': typeof AuthenticatedGoogleDocsConfigRoute
  '/google-drive-config': typeof AuthenticatedGoogleDriveConfigRoute
  '/important-documents': typeof AuthenticatedImportantDocumentsRoute
  '/invoices': typeof AuthenticatedInvoicesRoute
  '/kanban': typeof AuthenticatedKanbanRoute
  '/mattermost-config': typeof AuthenticatedMattermostConfigRoute
  '/mattermost-image-validation': typeof AuthenticatedMattermostImageValidationRoute
  '/mattermost-scheduled-messages': typeof AuthenticatedMattermostScheduledMessagesRouteWithChildren
  '/mattermost-sync-channels': typeof AuthenticatedMattermostSyncChannelsRoute
  '/meta-omnichannel': typeof AuthenticatedMetaOmnichannelRoute
  '/meta-omnichannel-config': typeof AuthenticatedMetaOmnichannelConfigRoute
  '/mindmaps': typeof AuthenticatedMindmapsRoute
  '/minha-empresa': typeof AuthenticatedMinhaEmpresaRoute
  '/my-dashboard': typeof AuthenticatedMyDashboardRoute
  '/my-passwords': typeof AuthenticatedMyPasswordsRoute
  '/my-requests': typeof AuthenticatedMyRequestsRoute
  '/notebook': typeof AuthenticatedNotebookRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/office-calendar-config': typeof AuthenticatedOfficeCalendarConfigRoute
  '/omnichannel-twilio': typeof AuthenticatedOmnichannelTwilioRoute
  '/omnichannel-twilio-config': typeof AuthenticatedOmnichannelTwilioConfigRoute
  '/passwords': typeof AuthenticatedPasswordsRoute
  '/points-dashboard': typeof AuthenticatedPointsDashboardRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/realtime': typeof AuthenticatedRealtimeRoute
  '/remote-commands': typeof AuthenticatedRemoteCommandsRoute
  '/requests': typeof AuthenticatedRequestsRoute
  '/roles': typeof AuthenticatedRolesRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/store': typeof AuthenticatedStoreRoute
  '/task-management': typeof AuthenticatedTaskManagementRoute
  '/task-planning-calendar': typeof AuthenticatedTaskPlanningCalendarRoute
  '/tasks-board': typeof AuthenticatedTasksBoardRoute
  '/tasks-history': typeof AuthenticatedTasksHistoryRoute
  '/team-calendar': typeof AuthenticatedTeamCalendarRoute
  '/teams': typeof AuthenticatedTeamsRoute
  '/users': typeof AuthenticatedUsersRoute
  '/users-birthdays': typeof AuthenticatedUsersBirthdaysRoute
  '/whatsapp-config': typeof AuthenticatedWhatsappConfigRoute
  '/system/ai-credit-packages': typeof SystemAiCreditPackagesRoute
  '/system/devices': typeof SystemDevicesRoute
  '/system/logs': typeof SystemLogsRoute
  '/system/plans': typeof SystemPlansRoute
  '/system/settings': typeof SystemSettingsRoute
  '/system/support': typeof SystemSupportRoute
  '/system/tenant-usage': typeof SystemTenantUsageRoute
  '/system/tenants': typeof SystemTenantsRoute
  '/system/users': typeof SystemUsersRoute
  '/system': typeof SystemIndexRoute
  '/admin/ai-credits': typeof AuthenticatedAdminAiCreditsRoute
  '/admin/branding': typeof AuthenticatedAdminBrandingRoute
  '/admin/clients-config': typeof AuthenticatedAdminClientsConfigRoute
  '/admin/features': typeof AuthenticatedAdminFeaturesRoute
  '/admin/gamification-events': typeof AuthenticatedAdminGamificationEventsRoute
  '/admin/mcp': typeof AuthenticatedAdminMcpRoute
  '/admin/notion-config': typeof AuthenticatedAdminNotionConfigRoute
  '/admin/office': typeof AuthenticatedAdminOfficeRoute
  '/admin/plans': typeof AuthenticatedAdminPlansRoute
  '/admin/recurring-client-tasks': typeof AuthenticatedAdminRecurringClientTasksRoute
  '/admin/store': typeof AuthenticatedAdminStoreRoute
  '/admin/subscription': typeof AuthenticatedAdminSubscriptionRoute
  '/admin/system-tenants': typeof AuthenticatedAdminSystemTenantsRoute
  '/ai-analysis/agents': typeof AuthenticatedAiAnalysisAgentsRoute
  '/ai-analysis/settings': typeof AuthenticatedAiAnalysisSettingsRoute
  '/client-contracts/history': typeof AuthenticatedClientContractsHistoryRoute
  '/client-contracts/settings': typeof AuthenticatedClientContractsSettingsRoute
  '/clients/$id': typeof AuthenticatedClientsIdRoute
  '/clients/board': typeof AuthenticatedClientsBoardRoute
  '/companies/$id': typeof AuthenticatedCompaniesIdRoute
  '/contracts/logs': typeof AuthenticatedContractsLogsRoute
  '/contracts/settings': typeof AuthenticatedContractsSettingsRoute
  '/employees/$id': typeof AuthenticatedEmployeesIdRoute
  '/employees/logs': typeof AuthenticatedEmployeesLogsRoute
  '/employees/payments': typeof AuthenticatedEmployeesPaymentsRoute
  '/employees/recess-control': typeof AuthenticatedEmployeesRecessControlRoute
  '/mattermost-scheduled-messages/new': typeof AuthenticatedMattermostScheduledMessagesNewRoute
  '/mcp/authorize': typeof AuthenticatedMcpAuthorizeRoute
  '/my-clients/$id': typeof AuthenticatedMyClientsIdRoute
  '/pipeline/kanban': typeof AuthenticatedPipelineKanbanRoute
  '/playbooks/$id': typeof AuthenticatedPlaybooksIdRoute
  '/playbooks/config': typeof AuthenticatedPlaybooksConfigRoute
  '/playbooks/my-steps': typeof AuthenticatedPlaybooksMyStepsRoute
  '/playbooks/new': typeof AuthenticatedPlaybooksNewRoute
  '/playbooks/templates': typeof AuthenticatedPlaybooksTemplatesRoute
  '/playbooks/triggers': typeof AuthenticatedPlaybooksTriggersRoute
  '/reimbursements/admin': typeof AuthenticatedReimbursementsAdminRoute
  '/reimbursements/analytics': typeof AuthenticatedReimbursementsAnalyticsRoute
  '/reimbursements/my-requests': typeof AuthenticatedReimbursementsMyRequestsRoute
  '/remote-access/$deviceId': typeof AuthenticatedRemoteAccessDeviceIdRoute
  '/tech-systems/$id': typeof AuthenticatedTechSystemsIdRoute
  '/tech-systems/config': typeof AuthenticatedTechSystemsConfigRoute
  '/invite/$code/$tenantId': typeof InviteCodeTenantIdRoute
  '/ai-analysis': typeof AuthenticatedAiAnalysisIndexRoute
  '/certification': typeof AuthenticatedCertificationIndexRoute
  '/client-contracts': typeof AuthenticatedClientContractsIndexRoute
  '/client-invoices': typeof AuthenticatedClientInvoicesIndexRoute
  '/clients': typeof AuthenticatedClientsIndexRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/contract-management': typeof AuthenticatedContractManagementIndexRoute
  '/contracts': typeof AuthenticatedContractsIndexRoute
  '/employees': typeof AuthenticatedEmployeesIndexRoute
  '/my-clients': typeof AuthenticatedMyClientsIndexRoute
  '/pipeline': typeof AuthenticatedPipelineIndexRoute
  '/playbooks': typeof AuthenticatedPlaybooksIndexRoute
  '/tech-systems': typeof AuthenticatedTechSystemsIndexRoute
  '/admin/invoices/missing': typeof AuthenticatedAdminInvoicesMissingRoute
  '/certification/certificados/$certificateId': typeof AuthenticatedCertificationCertificadosCertificateIdRoute
  '/certification/courses/$courseId': typeof AuthenticatedCertificationCoursesCourseIdRouteWithChildren
  '/contract-management/contracts/$id': typeof AuthenticatedContractManagementContractsIdRoute
  '/contract-management/templates/$id': typeof AuthenticatedContractManagementTemplatesIdRoute
  '/contract-management/templates/new': typeof AuthenticatedContractManagementTemplatesNewRoute
  '/pipeline/assets/$id': typeof AuthenticatedPipelineAssetsIdRoute
  '/pipeline/assets/novo': typeof AuthenticatedPipelineAssetsNovoRoute
  '/pipeline/leads/$id': typeof AuthenticatedPipelineLeadsIdRoute
  '/pipeline/leads/novo': typeof AuthenticatedPipelineLeadsNovoRoute
  '/playbooks/tasks/mine': typeof AuthenticatedPlaybooksTasksMineRoute
  '/tech-systems/projects/$id': typeof AuthenticatedTechSystemsProjectsIdRoute
  '/tech-systems/templates/$id': typeof AuthenticatedTechSystemsTemplatesIdRoute
  '/tech-systems/tickets/$ticketId': typeof AuthenticatedTechSystemsTicketsTicketIdRoute
  '/tech-systems/tickets/finance': typeof AuthenticatedTechSystemsTicketsFinanceRoute
  '/admin/invoices': typeof AuthenticatedAdminInvoicesIndexRoute
  '/certification/manage': typeof AuthenticatedCertificationManageIndexRoute
  '/pipeline/assets': typeof AuthenticatedPipelineAssetsIndexRoute
  '/pipeline/leads': typeof AuthenticatedPipelineLeadsIndexRoute
  '/tech-systems/projects': typeof AuthenticatedTechSystemsProjectsIndexRoute
  '/tech-systems/templates': typeof AuthenticatedTechSystemsTemplatesIndexRoute
  '/tech-systems/tickets': typeof AuthenticatedTechSystemsTicketsIndexRoute
  '/admin/invoices/submitted/$userId': typeof AuthenticatedAdminInvoicesSubmittedUserIdRoute
  '/certification/courses/$courseId/simulado': typeof AuthenticatedCertificationCoursesCourseIdSimuladoRoute
  '/admin/invoices/submitted': typeof AuthenticatedAdminInvoicesSubmittedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/system': typeof SystemRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/calendar-oauth-callback': typeof CalendarOauthCallbackRoute
  '/exclusao-de-dados': typeof ExclusaoDeDadosRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/google-drive-oauth-callback': typeof GoogleDriveOauthCallbackRoute
  '/login': typeof LoginRoute
  '/politica-cookie': typeof PoliticaCookieRoute
  '/politica-privacidade': typeof PoliticaPrivacidadeRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sso': typeof SsoRoute
  '/system-login': typeof SystemLoginRoute
  '/termos-de-uso': typeof TermosDeUsoRoute
  '/_authenticated/admin-dashboard': typeof AuthenticatedAdminDashboardRoute
  '/_authenticated/admin-tasks-board': typeof AuthenticatedAdminTasksBoardRoute
  '/_authenticated/asset-kits': typeof AuthenticatedAssetKitsRoute
  '/_authenticated/assets': typeof AuthenticatedAssetsRoute
  '/_authenticated/calendar': typeof AuthenticatedCalendarRoute
  '/_authenticated/calendar-captation-approvals': typeof AuthenticatedCalendarCaptationApprovalsRoute
  '/_authenticated/calendar-captations': typeof AuthenticatedCalendarCaptationsRoute
  '/_authenticated/calendar-config': typeof AuthenticatedCalendarConfigRoute
  '/_authenticated/categories': typeof AuthenticatedCategoriesRoute
  '/_authenticated/cnpj-search': typeof AuthenticatedCnpjSearchRoute
  '/_authenticated/company-documents': typeof AuthenticatedCompanyDocumentsRoute
  '/_authenticated/contract-management': typeof AuthenticatedContractManagementRouteWithChildren
  '/_authenticated/desktop-versions': typeof AuthenticatedDesktopVersionsRoute
  '/_authenticated/documents-access-history': typeof AuthenticatedDocumentsAccessHistoryRoute
  '/_authenticated/documents-management': typeof AuthenticatedDocumentsManagementRoute
  '/_authenticated/drive-manager': typeof AuthenticatedDriveManagerRoute
  '/_authenticated/equipments': typeof AuthenticatedEquipmentsRoute
  '/_authenticated/external-integrations': typeof AuthenticatedExternalIntegrationsRoute
  '/_authenticated/gemini-config': typeof AuthenticatedGeminiConfigRoute
  '/_authenticated/google-docs-config': typeof AuthenticatedGoogleDocsConfigRoute
  '/_authenticated/google-drive-config': typeof AuthenticatedGoogleDriveConfigRoute
  '/_authenticated/important-documents': typeof AuthenticatedImportantDocumentsRoute
  '/_authenticated/invoices': typeof AuthenticatedInvoicesRoute
  '/_authenticated/kanban': typeof AuthenticatedKanbanRoute
  '/_authenticated/mattermost-config': typeof AuthenticatedMattermostConfigRoute
  '/_authenticated/mattermost-image-validation': typeof AuthenticatedMattermostImageValidationRoute
  '/_authenticated/mattermost-scheduled-messages': typeof AuthenticatedMattermostScheduledMessagesRouteWithChildren
  '/_authenticated/mattermost-sync-channels': typeof AuthenticatedMattermostSyncChannelsRoute
  '/_authenticated/meta-omnichannel': typeof AuthenticatedMetaOmnichannelRoute
  '/_authenticated/meta-omnichannel-config': typeof AuthenticatedMetaOmnichannelConfigRoute
  '/_authenticated/mindmaps': typeof AuthenticatedMindmapsRoute
  '/_authenticated/minha-empresa': typeof AuthenticatedMinhaEmpresaRoute
  '/_authenticated/my-dashboard': typeof AuthenticatedMyDashboardRoute
  '/_authenticated/my-passwords': typeof AuthenticatedMyPasswordsRoute
  '/_authenticated/my-requests': typeof AuthenticatedMyRequestsRoute
  '/_authenticated/notebook': typeof AuthenticatedNotebookRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/office-calendar-config': typeof AuthenticatedOfficeCalendarConfigRoute
  '/_authenticated/omnichannel-twilio': typeof AuthenticatedOmnichannelTwilioRoute
  '/_authenticated/omnichannel-twilio-config': typeof AuthenticatedOmnichannelTwilioConfigRoute
  '/_authenticated/passwords': typeof AuthenticatedPasswordsRoute
  '/_authenticated/points-dashboard': typeof AuthenticatedPointsDashboardRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/realtime': typeof AuthenticatedRealtimeRoute
  '/_authenticated/remote-commands': typeof AuthenticatedRemoteCommandsRoute
  '/_authenticated/requests': typeof AuthenticatedRequestsRoute
  '/_authenticated/roles': typeof AuthenticatedRolesRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/store': typeof AuthenticatedStoreRoute
  '/_authenticated/task-management': typeof AuthenticatedTaskManagementRoute
  '/_authenticated/task-planning-calendar': typeof AuthenticatedTaskPlanningCalendarRoute
  '/_authenticated/tasks-board': typeof AuthenticatedTasksBoardRoute
  '/_authenticated/tasks-history': typeof AuthenticatedTasksHistoryRoute
  '/_authenticated/team-calendar': typeof AuthenticatedTeamCalendarRoute
  '/_authenticated/teams': typeof AuthenticatedTeamsRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/_authenticated/users-birthdays': typeof AuthenticatedUsersBirthdaysRoute
  '/_authenticated/whatsapp-config': typeof AuthenticatedWhatsappConfigRoute
  '/system/ai-credit-packages': typeof SystemAiCreditPackagesRoute
  '/system/devices': typeof SystemDevicesRoute
  '/system/logs': typeof SystemLogsRoute
  '/system/plans': typeof SystemPlansRoute
  '/system/settings': typeof SystemSettingsRoute
  '/system/support': typeof SystemSupportRoute
  '/system/tenant-usage': typeof SystemTenantUsageRoute
  '/system/tenants': typeof SystemTenantsRoute
  '/system/users': typeof SystemUsersRoute
  '/system/': typeof SystemIndexRoute
  '/_authenticated/admin/ai-credits': typeof AuthenticatedAdminAiCreditsRoute
  '/_authenticated/admin/branding': typeof AuthenticatedAdminBrandingRoute
  '/_authenticated/admin/clients-config': typeof AuthenticatedAdminClientsConfigRoute
  '/_authenticated/admin/features': typeof AuthenticatedAdminFeaturesRoute
  '/_authenticated/admin/gamification-events': typeof AuthenticatedAdminGamificationEventsRoute
  '/_authenticated/admin/mcp': typeof AuthenticatedAdminMcpRoute
  '/_authenticated/admin/notion-config': typeof AuthenticatedAdminNotionConfigRoute
  '/_authenticated/admin/office': typeof AuthenticatedAdminOfficeRoute
  '/_authenticated/admin/plans': typeof AuthenticatedAdminPlansRoute
  '/_authenticated/admin/recurring-client-tasks': typeof AuthenticatedAdminRecurringClientTasksRoute
  '/_authenticated/admin/store': typeof AuthenticatedAdminStoreRoute
  '/_authenticated/admin/subscription': typeof AuthenticatedAdminSubscriptionRoute
  '/_authenticated/admin/system-tenants': typeof AuthenticatedAdminSystemTenantsRoute
  '/_authenticated/ai-analysis/agents': typeof AuthenticatedAiAnalysisAgentsRoute
  '/_authenticated/ai-analysis/settings': typeof AuthenticatedAiAnalysisSettingsRoute
  '/_authenticated/client-contracts/history': typeof AuthenticatedClientContractsHistoryRoute
  '/_authenticated/client-contracts/settings': typeof AuthenticatedClientContractsSettingsRoute
  '/_authenticated/clients/$id': typeof AuthenticatedClientsIdRoute
  '/_authenticated/clients/board': typeof AuthenticatedClientsBoardRoute
  '/_authenticated/companies/$id': typeof AuthenticatedCompaniesIdRoute
  '/_authenticated/contracts/logs': typeof AuthenticatedContractsLogsRoute
  '/_authenticated/contracts/settings': typeof AuthenticatedContractsSettingsRoute
  '/_authenticated/employees/$id': typeof AuthenticatedEmployeesIdRoute
  '/_authenticated/employees/logs': typeof AuthenticatedEmployeesLogsRoute
  '/_authenticated/employees/payments': typeof AuthenticatedEmployeesPaymentsRoute
  '/_authenticated/employees/recess-control': typeof AuthenticatedEmployeesRecessControlRoute
  '/_authenticated/mattermost-scheduled-messages/new': typeof AuthenticatedMattermostScheduledMessagesNewRoute
  '/_authenticated/mcp/authorize': typeof AuthenticatedMcpAuthorizeRoute
  '/_authenticated/my-clients/$id': typeof AuthenticatedMyClientsIdRoute
  '/_authenticated/pipeline/kanban': typeof AuthenticatedPipelineKanbanRoute
  '/_authenticated/playbooks/$id': typeof AuthenticatedPlaybooksIdRoute
  '/_authenticated/playbooks/config': typeof AuthenticatedPlaybooksConfigRoute
  '/_authenticated/playbooks/my-steps': typeof AuthenticatedPlaybooksMyStepsRoute
  '/_authenticated/playbooks/new': typeof AuthenticatedPlaybooksNewRoute
  '/_authenticated/playbooks/templates': typeof AuthenticatedPlaybooksTemplatesRoute
  '/_authenticated/playbooks/triggers': typeof AuthenticatedPlaybooksTriggersRoute
  '/_authenticated/reimbursements/admin': typeof AuthenticatedReimbursementsAdminRoute
  '/_authenticated/reimbursements/analytics': typeof AuthenticatedReimbursementsAnalyticsRoute
  '/_authenticated/reimbursements/my-requests': typeof AuthenticatedReimbursementsMyRequestsRoute
  '/_authenticated/remote-access/$deviceId': typeof AuthenticatedRemoteAccessDeviceIdRoute
  '/_authenticated/tech-systems/$id': typeof AuthenticatedTechSystemsIdRoute
  '/_authenticated/tech-systems/config': typeof AuthenticatedTechSystemsConfigRoute
  '/invite/$code/$tenantId': typeof InviteCodeTenantIdRoute
  '/_authenticated/ai-analysis/': typeof AuthenticatedAiAnalysisIndexRoute
  '/_authenticated/certification/': typeof AuthenticatedCertificationIndexRoute
  '/_authenticated/client-contracts/': typeof AuthenticatedClientContractsIndexRoute
  '/_authenticated/client-invoices/': typeof AuthenticatedClientInvoicesIndexRoute
  '/_authenticated/clients/': typeof AuthenticatedClientsIndexRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/contract-management/': typeof AuthenticatedContractManagementIndexRoute
  '/_authenticated/contracts/': typeof AuthenticatedContractsIndexRoute
  '/_authenticated/employees/': typeof AuthenticatedEmployeesIndexRoute
  '/_authenticated/my-clients/': typeof AuthenticatedMyClientsIndexRoute
  '/_authenticated/pipeline/': typeof AuthenticatedPipelineIndexRoute
  '/_authenticated/playbooks/': typeof AuthenticatedPlaybooksIndexRoute
  '/_authenticated/tech-systems/': typeof AuthenticatedTechSystemsIndexRoute
  '/_authenticated/admin/invoices/missing': typeof AuthenticatedAdminInvoicesMissingRoute
  '/_authenticated/certification/certificados/$certificateId': typeof AuthenticatedCertificationCertificadosCertificateIdRoute
  '/_authenticated/certification/courses/$courseId': typeof AuthenticatedCertificationCoursesCourseIdRouteWithChildren
  '/_authenticated/contract-management/contracts/$id': typeof AuthenticatedContractManagementContractsIdRoute
  '/_authenticated/contract-management/templates/$id': typeof AuthenticatedContractManagementTemplatesIdRoute
  '/_authenticated/contract-management/templates/new': typeof AuthenticatedContractManagementTemplatesNewRoute
  '/_authenticated/pipeline/assets/$id': typeof AuthenticatedPipelineAssetsIdRoute
  '/_authenticated/pipeline/assets/novo': typeof AuthenticatedPipelineAssetsNovoRoute
  '/_authenticated/pipeline/leads/$id': typeof AuthenticatedPipelineLeadsIdRoute
  '/_authenticated/pipeline/leads/novo': typeof AuthenticatedPipelineLeadsNovoRoute
  '/_authenticated/playbooks/tasks/mine': typeof AuthenticatedPlaybooksTasksMineRoute
  '/_authenticated/tech-systems/projects/$id': typeof AuthenticatedTechSystemsProjectsIdRoute
  '/_authenticated/tech-systems/templates/$id': typeof AuthenticatedTechSystemsTemplatesIdRoute
  '/_authenticated/tech-systems/tickets/$ticketId': typeof AuthenticatedTechSystemsTicketsTicketIdRoute
  '/_authenticated/tech-systems/tickets/finance': typeof AuthenticatedTechSystemsTicketsFinanceRoute
  '/_authenticated/admin/invoices/': typeof AuthenticatedAdminInvoicesIndexRoute
  '/_authenticated/certification/manage/': typeof AuthenticatedCertificationManageIndexRoute
  '/_authenticated/pipeline/assets/': typeof AuthenticatedPipelineAssetsIndexRoute
  '/_authenticated/pipeline/leads/': typeof AuthenticatedPipelineLeadsIndexRoute
  '/_authenticated/tech-systems/projects/': typeof AuthenticatedTechSystemsProjectsIndexRoute
  '/_authenticated/tech-systems/templates/': typeof AuthenticatedTechSystemsTemplatesIndexRoute
  '/_authenticated/tech-systems/tickets/': typeof AuthenticatedTechSystemsTicketsIndexRoute
  '/_authenticated/admin/invoices/submitted/$userId': typeof AuthenticatedAdminInvoicesSubmittedUserIdRoute
  '/_authenticated/certification/courses/$courseId/simulado': typeof AuthenticatedCertificationCoursesCourseIdSimuladoRoute
  '/_authenticated/admin/invoices/submitted/': typeof AuthenticatedAdminInvoicesSubmittedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/system'
    | '/calendar-oauth-callback'
    | '/exclusao-de-dados'
    | '/forgot-password'
    | '/google-drive-oauth-callback'
    | '/login'
    | '/politica-cookie'
    | '/politica-privacidade'
    | '/register'
    | '/reset-password'
    | '/sso'
    | '/system-login'
    | '/termos-de-uso'
    | '/admin-dashboard'
    | '/admin-tasks-board'
    | '/asset-kits'
    | '/assets'
    | '/calendar'
    | '/calendar-captation-approvals'
    | '/calendar-captations'
    | '/calendar-config'
    | '/categories'
    | '/cnpj-search'
    | '/company-documents'
    | '/contract-management'
    | '/desktop-versions'
    | '/documents-access-history'
    | '/documents-management'
    | '/drive-manager'
    | '/equipments'
    | '/external-integrations'
    | '/gemini-config'
    | '/google-docs-config'
    | '/google-drive-config'
    | '/important-documents'
    | '/invoices'
    | '/kanban'
    | '/mattermost-config'
    | '/mattermost-image-validation'
    | '/mattermost-scheduled-messages'
    | '/mattermost-sync-channels'
    | '/meta-omnichannel'
    | '/meta-omnichannel-config'
    | '/mindmaps'
    | '/minha-empresa'
    | '/my-dashboard'
    | '/my-passwords'
    | '/my-requests'
    | '/notebook'
    | '/notifications'
    | '/office-calendar-config'
    | '/omnichannel-twilio'
    | '/omnichannel-twilio-config'
    | '/passwords'
    | '/points-dashboard'
    | '/profile'
    | '/realtime'
    | '/remote-commands'
    | '/requests'
    | '/roles'
    | '/settings'
    | '/store'
    | '/task-management'
    | '/task-planning-calendar'
    | '/tasks-board'
    | '/tasks-history'
    | '/team-calendar'
    | '/teams'
    | '/users'
    | '/users-birthdays'
    | '/whatsapp-config'
    | '/system/ai-credit-packages'
    | '/system/devices'
    | '/system/logs'
    | '/system/plans'
    | '/system/settings'
    | '/system/support'
    | '/system/tenant-usage'
    | '/system/tenants'
    | '/system/users'
    | '/system/'
    | '/admin/ai-credits'
    | '/admin/branding'
    | '/admin/clients-config'
    | '/admin/features'
    | '/admin/gamification-events'
    | '/admin/mcp'
    | '/admin/notion-config'
    | '/admin/office'
    | '/admin/plans'
    | '/admin/recurring-client-tasks'
    | '/admin/store'
    | '/admin/subscription'
    | '/admin/system-tenants'
    | '/ai-analysis/agents'
    | '/ai-analysis/settings'
    | '/client-contracts/history'
    | '/client-contracts/settings'
    | '/clients/$id'
    | '/clients/board'
    | '/companies/$id'
    | '/contracts/logs'
    | '/contracts/settings'
    | '/employees/$id'
    | '/employees/logs'
    | '/employees/payments'
    | '/employees/recess-control'
    | '/mattermost-scheduled-messages/new'
    | '/mcp/authorize'
    | '/my-clients/$id'
    | '/pipeline/kanban'
    | '/playbooks/$id'
    | '/playbooks/config'
    | '/playbooks/my-steps'
    | '/playbooks/new'
    | '/playbooks/templates'
    | '/playbooks/triggers'
    | '/reimbursements/admin'
    | '/reimbursements/analytics'
    | '/reimbursements/my-requests'
    | '/remote-access/$deviceId'
    | '/tech-systems/$id'
    | '/tech-systems/config'
    | '/invite/$code/$tenantId'
    | '/ai-analysis/'
    | '/certification/'
    | '/client-contracts/'
    | '/client-invoices/'
    | '/clients/'
    | '/companies/'
    | '/contract-management/'
    | '/contracts/'
    | '/employees/'
    | '/my-clients/'
    | '/pipeline/'
    | '/playbooks/'
    | '/tech-systems/'
    | '/admin/invoices/missing'
    | '/certification/certificados/$certificateId'
    | '/certification/courses/$courseId'
    | '/contract-management/contracts/$id'
    | '/contract-management/templates/$id'
    | '/contract-management/templates/new'
    | '/pipeline/assets/$id'
    | '/pipeline/assets/novo'
    | '/pipeline/leads/$id'
    | '/pipeline/leads/novo'
    | '/playbooks/tasks/mine'
    | '/tech-systems/projects/$id'
    | '/tech-systems/templates/$id'
    | '/tech-systems/tickets/$ticketId'
    | '/tech-systems/tickets/finance'
    | '/admin/invoices/'
    | '/certification/manage/'
    | '/pipeline/assets/'
    | '/pipeline/leads/'
    | '/tech-systems/projects/'
    | '/tech-systems/templates/'
    | '/tech-systems/tickets/'
    | '/admin/invoices/submitted/$userId'
    | '/certification/courses/$courseId/simulado'
    | '/admin/invoices/submitted/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/calendar-oauth-callback'
    | '/exclusao-de-dados'
    | '/forgot-password'
    | '/google-drive-oauth-callback'
    | '/login'
    | '/politica-cookie'
    | '/politica-privacidade'
    | '/register'
    | '/reset-password'
    | '/sso'
    | '/system-login'
    | '/termos-de-uso'
    | '/admin-dashboard'
    | '/admin-tasks-board'
    | '/asset-kits'
    | '/assets'
    | '/calendar'
    | '/calendar-captation-approvals'
    | '/calendar-captations'
    | '/calendar-config'
    | '/categories'
    | '/cnpj-search'
    | '/company-documents'
    | '/desktop-versions'
    | '/documents-access-history'
    | '/documents-management'
    | '/drive-manager'
    | '/equipments'
    | '/external-integrations'
    | '/gemini-config'
    | '/google-docs-config'
    | '/google-drive-config'
    | '/important-documents'
    | '/invoices'
    | '/kanban'
    | '/mattermost-config'
    | '/mattermost-image-validation'
    | '/mattermost-scheduled-messages'
    | '/mattermost-sync-channels'
    | '/meta-omnichannel'
    | '/meta-omnichannel-config'
    | '/mindmaps'
    | '/minha-empresa'
    | '/my-dashboard'
    | '/my-passwords'
    | '/my-requests'
    | '/notebook'
    | '/notifications'
    | '/office-calendar-config'
    | '/omnichannel-twilio'
    | '/omnichannel-twilio-config'
    | '/passwords'
    | '/points-dashboard'
    | '/profile'
    | '/realtime'
    | '/remote-commands'
    | '/requests'
    | '/roles'
    | '/settings'
    | '/store'
    | '/task-management'
    | '/task-planning-calendar'
    | '/tasks-board'
    | '/tasks-history'
    | '/team-calendar'
    | '/teams'
    | '/users'
    | '/users-birthdays'
    | '/whatsapp-config'
    | '/system/ai-credit-packages'
    | '/system/devices'
    | '/system/logs'
    | '/system/plans'
    | '/system/settings'
    | '/system/support'
    | '/system/tenant-usage'
    | '/system/tenants'
    | '/system/users'
    | '/system'
    | '/admin/ai-credits'
    | '/admin/branding'
    | '/admin/clients-config'
    | '/admin/features'
    | '/admin/gamification-events'
    | '/admin/mcp'
    | '/admin/notion-config'
    | '/admin/office'
    | '/admin/plans'
    | '/admin/recurring-client-tasks'
    | '/admin/store'
    | '/admin/subscription'
    | '/admin/system-tenants'
    | '/ai-analysis/agents'
    | '/ai-analysis/settings'
    | '/client-contracts/history'
    | '/client-contracts/settings'
    | '/clients/$id'
    | '/clients/board'
    | '/companies/$id'
    | '/contracts/logs'
    | '/contracts/settings'
    | '/employees/$id'
    | '/employees/logs'
    | '/employees/payments'
    | '/employees/recess-control'
    | '/mattermost-scheduled-messages/new'
    | '/mcp/authorize'
    | '/my-clients/$id'
    | '/pipeline/kanban'
    | '/playbooks/$id'
    | '/playbooks/config'
    | '/playbooks/my-steps'
    | '/playbooks/new'
    | '/playbooks/templates'
    | '/playbooks/triggers'
    | '/reimbursements/admin'
    | '/reimbursements/analytics'
    | '/reimbursements/my-requests'
    | '/remote-access/$deviceId'
    | '/tech-systems/$id'
    | '/tech-systems/config'
    | '/invite/$code/$tenantId'
    | '/ai-analysis'
    | '/certification'
    | '/client-contracts'
    | '/client-invoices'
    | '/clients'
    | '/companies'
    | '/contract-management'
    | '/contracts'
    | '/employees'
    | '/my-clients'
    | '/pipeline'
    | '/playbooks'
    | '/tech-systems'
    | '/admin/invoices/missing'
    | '/certification/certificados/$certificateId'
    | '/certification/courses/$courseId'
    | '/contract-management/contracts/$id'
    | '/contract-management/templates/$id'
    | '/contract-management/templates/new'
    | '/pipeline/assets/$id'
    | '/pipeline/assets/novo'
    | '/pipeline/leads/$id'
    | '/pipeline/leads/novo'
    | '/playbooks/tasks/mine'
    | '/tech-systems/projects/$id'
    | '/tech-systems/templates/$id'
    | '/tech-systems/tickets/$ticketId'
    | '/tech-systems/tickets/finance'
    | '/admin/invoices'
    | '/certification/manage'
    | '/pipeline/assets'
    | '/pipeline/leads'
    | '/tech-systems/projects'
    | '/tech-systems/templates'
    | '/tech-systems/tickets'
    | '/admin/invoices/submitted/$userId'
    | '/certification/courses/$courseId/simulado'
    | '/admin/invoices/submitted'
  id:
    | '__root__'
    | '/'
    | '/system'
    | '/_authenticated'
    | '/calendar-oauth-callback'
    | '/exclusao-de-dados'
    | '/forgot-password'
    | '/google-drive-oauth-callback'
    | '/login'
    | '/politica-cookie'
    | '/politica-privacidade'
    | '/register'
    | '/reset-password'
    | '/sso'
    | '/system-login'
    | '/termos-de-uso'
    | '/_authenticated/admin-dashboard'
    | '/_authenticated/admin-tasks-board'
    | '/_authenticated/asset-kits'
    | '/_authenticated/assets'
    | '/_authenticated/calendar'
    | '/_authenticated/calendar-captation-approvals'
    | '/_authenticated/calendar-captations'
    | '/_authenticated/calendar-config'
    | '/_authenticated/categories'
    | '/_authenticated/cnpj-search'
    | '/_authenticated/company-documents'
    | '/_authenticated/contract-management'
    | '/_authenticated/desktop-versions'
    | '/_authenticated/documents-access-history'
    | '/_authenticated/documents-management'
    | '/_authenticated/drive-manager'
    | '/_authenticated/equipments'
    | '/_authenticated/external-integrations'
    | '/_authenticated/gemini-config'
    | '/_authenticated/google-docs-config'
    | '/_authenticated/google-drive-config'
    | '/_authenticated/important-documents'
    | '/_authenticated/invoices'
    | '/_authenticated/kanban'
    | '/_authenticated/mattermost-config'
    | '/_authenticated/mattermost-image-validation'
    | '/_authenticated/mattermost-scheduled-messages'
    | '/_authenticated/mattermost-sync-channels'
    | '/_authenticated/meta-omnichannel'
    | '/_authenticated/meta-omnichannel-config'
    | '/_authenticated/mindmaps'
    | '/_authenticated/minha-empresa'
    | '/_authenticated/my-dashboard'
    | '/_authenticated/my-passwords'
    | '/_authenticated/my-requests'
    | '/_authenticated/notebook'
    | '/_authenticated/notifications'
    | '/_authenticated/office-calendar-config'
    | '/_authenticated/omnichannel-twilio'
    | '/_authenticated/omnichannel-twilio-config'
    | '/_authenticated/passwords'
    | '/_authenticated/points-dashboard'
    | '/_authenticated/profile'
    | '/_authenticated/realtime'
    | '/_authenticated/remote-commands'
    | '/_authenticated/requests'
    | '/_authenticated/roles'
    | '/_authenticated/settings'
    | '/_authenticated/store'
    | '/_authenticated/task-management'
    | '/_authenticated/task-planning-calendar'
    | '/_authenticated/tasks-board'
    | '/_authenticated/tasks-history'
    | '/_authenticated/team-calendar'
    | '/_authenticated/teams'
    | '/_authenticated/users'
    | '/_authenticated/users-birthdays'
    | '/_authenticated/whatsapp-config'
    | '/system/ai-credit-packages'
    | '/system/devices'
    | '/system/logs'
    | '/system/plans'
    | '/system/settings'
    | '/system/support'
    | '/system/tenant-usage'
    | '/system/tenants'
    | '/system/users'
    | '/system/'
    | '/_authenticated/admin/ai-credits'
    | '/_authenticated/admin/branding'
    | '/_authenticated/admin/clients-config'
    | '/_authenticated/admin/features'
    | '/_authenticated/admin/gamification-events'
    | '/_authenticated/admin/mcp'
    | '/_authenticated/admin/notion-config'
    | '/_authenticated/admin/office'
    | '/_authenticated/admin/plans'
    | '/_authenticated/admin/recurring-client-tasks'
    | '/_authenticated/admin/store'
    | '/_authenticated/admin/subscription'
    | '/_authenticated/admin/system-tenants'
    | '/_authenticated/ai-analysis/agents'
    | '/_authenticated/ai-analysis/settings'
    | '/_authenticated/client-contracts/history'
    | '/_authenticated/client-contracts/settings'
    | '/_authenticated/clients/$id'
    | '/_authenticated/clients/board'
    | '/_authenticated/companies/$id'
    | '/_authenticated/contracts/logs'
    | '/_authenticated/contracts/settings'
    | '/_authenticated/employees/$id'
    | '/_authenticated/employees/logs'
    | '/_authenticated/employees/payments'
    | '/_authenticated/employees/recess-control'
    | '/_authenticated/mattermost-scheduled-messages/new'
    | '/_authenticated/mcp/authorize'
    | '/_authenticated/my-clients/$id'
    | '/_authenticated/pipeline/kanban'
    | '/_authenticated/playbooks/$id'
    | '/_authenticated/playbooks/config'
    | '/_authenticated/playbooks/my-steps'
    | '/_authenticated/playbooks/new'
    | '/_authenticated/playbooks/templates'
    | '/_authenticated/playbooks/triggers'
    | '/_authenticated/reimbursements/admin'
    | '/_authenticated/reimbursements/analytics'
    | '/_authenticated/reimbursements/my-requests'
    | '/_authenticated/remote-access/$deviceId'
    | '/_authenticated/tech-systems/$id'
    | '/_authenticated/tech-systems/config'
    | '/invite/$code/$tenantId'
    | '/_authenticated/ai-analysis/'
    | '/_authenticated/certification/'
    | '/_authenticated/client-contracts/'
    | '/_authenticated/client-invoices/'
    | '/_authenticated/clients/'
    | '/_authenticated/companies/'
    | '/_authenticated/contract-management/'
    | '/_authenticated/contracts/'
    | '/_authenticated/employees/'
    | '/_authenticated/my-clients/'
    | '/_authenticated/pipeline/'
    | '/_authenticated/playbooks/'
    | '/_authenticated/tech-systems/'
    | '/_authenticated/admin/invoices/missing'
    | '/_authenticated/certification/certificados/$certificateId'
    | '/_authenticated/certification/courses/$courseId'
    | '/_authenticated/contract-management/contracts/$id'
    | '/_authenticated/contract-management/templates/$id'
    | '/_authenticated/contract-management/templates/new'
    | '/_authenticated/pipeline/assets/$id'
    | '/_authenticated/pipeline/assets/novo'
    | '/_authenticated/pipeline/leads/$id'
    | '/_authenticated/pipeline/leads/novo'
    | '/_authenticated/playbooks/tasks/mine'
    | '/_authenticated/tech-systems/projects/$id'
    | '/_authenticated/tech-systems/templates/$id'
    | '/_authenticated/tech-systems/tickets/$ticketId'
    | '/_authenticated/tech-systems/tickets/finance'
    | '/_authenticated/admin/invoices/'
    | '/_authenticated/certification/manage/'
    | '/_authenticated/pipeline/assets/'
    | '/_authenticated/pipeline/leads/'
    | '/_authenticated/tech-systems/projects/'
    | '/_authenticated/tech-systems/templates/'
    | '/_authenticated/tech-systems/tickets/'
    | '/_authenticated/admin/invoices/submitted/$userId'
    | '/_authenticated/certification/courses/$courseId/simulado'
    | '/_authenticated/admin/invoices/submitted/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SystemRouteRoute: typeof SystemRouteRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CalendarOauthCallbackRoute: typeof CalendarOauthCallbackRoute
  ExclusaoDeDadosRoute: typeof ExclusaoDeDadosRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  GoogleDriveOauthCallbackRoute: typeof GoogleDriveOauthCallbackRoute
  LoginRoute: typeof LoginRoute
  PoliticaCookieRoute: typeof PoliticaCookieRoute
  PoliticaPrivacidadeRoute: typeof PoliticaPrivacidadeRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SsoRoute: typeof SsoRoute
  SystemLoginRoute: typeof SystemLoginRoute
  TermosDeUsoRoute: typeof TermosDeUsoRoute
  InviteCodeTenantIdRoute: typeof InviteCodeTenantIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/termos-de-uso': {
      id: '/termos-de-uso'
      path: '/termos-de-uso'
      fullPath: '/termos-de-uso'
      preLoaderRoute: typeof TermosDeUsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system-login': {
      id: '/system-login'
      path: '/system-login'
      fullPath: '/system-login'
      preLoaderRoute: typeof SystemLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso': {
      id: '/sso'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof SsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politica-privacidade': {
      id: '/politica-privacidade'
      path: '/politica-privacidade'
      fullPath: '/politica-privacidade'
      preLoaderRoute: typeof PoliticaPrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politica-cookie': {
      id: '/politica-cookie'
      path: '/politica-cookie'
      fullPath: '/politica-cookie'
      preLoaderRoute: typeof PoliticaCookieRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/google-drive-oauth-callback': {
      id: '/google-drive-oauth-callback'
      path: '/google-drive-oauth-callback'
      fullPath: '/google-drive-oauth-callback'
      preLoaderRoute: typeof GoogleDriveOauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exclusao-de-dados': {
      id: '/exclusao-de-dados'
      path: '/exclusao-de-dados'
      fullPath: '/exclusao-de-dados'
      preLoaderRoute: typeof ExclusaoDeDadosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar-oauth-callback': {
      id: '/calendar-oauth-callback'
      path: '/calendar-oauth-callback'
      fullPath: '/calendar-oauth-callback'
      preLoaderRoute: typeof CalendarOauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system': {
      id: '/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof SystemRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/': {
      id: '/system/'
      path: '/'
      fullPath: '/system/'
      preLoaderRoute: typeof SystemIndexRouteImport
      parentRoute: typeof SystemRouteRoute
    }
    '/system/users': {
      id: '/system/users'
      path: '/users'
      fullPath: '/system/users'
      preLoaderRoute: typeof SystemUsersRouteImport
      parentRoute: typeof SystemRouteRoute
    }
    '/system/tenants': {
      id: '/system/tenants'
      path: '/tenants'
      fullPath: '/system/tenants'
      preLoaderRoute: typeof SystemTenantsRouteImport
      parentRoute: typeof SystemRouteRoute
    }
    '/system/tenant-usage': {
      id: '/system/tenant-usage'
      path: '/tenant-usage'
      fullPath: '/system/tenant-usage'
      preLoaderRoute: typeof SystemTenantUsageRouteImport
      parentRoute: typeof SystemRouteRoute
    }
    '/system/support': {
      id: '/system/support'
      path: '/support'
      fullPath: '/system/support'
      preLoaderRoute: typeof SystemSupportRouteImport
      parentRoute: typeof SystemRouteRoute
    }
    '/system/settings': {
      id: '/system/settings'
      path: '/settings'
      fullPath: '/system/settings'
      preLoaderRoute: typeof SystemSettingsRouteImport
      parentRoute: typeof SystemRouteRoute
    }
    '/system/plans': {
      id: '/system/plans'
      path: '/plans'
      fullPath: '/system/plans'
      preLoaderRoute: typeof SystemPlansRouteImport
      parentRoute: typeof SystemRouteRoute
    }
    '/system/logs': {
      id: '/system/logs'
      path: '/logs'
      fullPath: '/system/logs'
      preLoaderRoute: typeof SystemLogsRouteImport
      parentRoute: typeof SystemRouteRoute
    }
    '/system/devices': {
      id: '/system/devices'
      path: '/devices'
      fullPath: '/system/devices'
      preLoaderRoute: typeof SystemDevicesRouteImport
      parentRoute: typeof SystemRouteRoute
    }
    '/system/ai-credit-packages': {
      id: '/system/ai-credit-packages'
      path: '/ai-credit-packages'
      fullPath: '/system/ai-credit-packages'
      preLoaderRoute: typeof SystemAiCreditPackagesRouteImport
      parentRoute: typeof SystemRouteRoute
    }
    '/_authenticated/whatsapp-config': {
      id: '/_authenticated/whatsapp-config'
      path: '/whatsapp-config'
      fullPath: '/whatsapp-config'
      preLoaderRoute: typeof AuthenticatedWhatsappConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users-birthdays': {
      id: '/_authenticated/users-birthdays'
      path: '/users-birthdays'
      fullPath: '/users-birthdays'
      preLoaderRoute: typeof AuthenticatedUsersBirthdaysRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/teams': {
      id: '/_authenticated/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof AuthenticatedTeamsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/team-calendar': {
      id: '/_authenticated/team-calendar'
      path: '/team-calendar'
      fullPath: '/team-calendar'
      preLoaderRoute: typeof AuthenticatedTeamCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks-history': {
      id: '/_authenticated/tasks-history'
      path: '/tasks-history'
      fullPath: '/tasks-history'
      preLoaderRoute: typeof AuthenticatedTasksHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks-board': {
      id: '/_authenticated/tasks-board'
      path: '/tasks-board'
      fullPath: '/tasks-board'
      preLoaderRoute: typeof AuthenticatedTasksBoardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/task-planning-calendar': {
      id: '/_authenticated/task-planning-calendar'
      path: '/task-planning-calendar'
      fullPath: '/task-planning-calendar'
      preLoaderRoute: typeof AuthenticatedTaskPlanningCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/task-management': {
      id: '/_authenticated/task-management'
      path: '/task-management'
      fullPath: '/task-management'
      preLoaderRoute: typeof AuthenticatedTaskManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/store': {
      id: '/_authenticated/store'
      path: '/store'
      fullPath: '/store'
      preLoaderRoute: typeof AuthenticatedStoreRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles': {
      id: '/_authenticated/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AuthenticatedRolesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/requests': {
      id: '/_authenticated/requests'
      path: '/requests'
      fullPath: '/requests'
      preLoaderRoute: typeof AuthenticatedRequestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/remote-commands': {
      id: '/_authenticated/remote-commands'
      path: '/remote-commands'
      fullPath: '/remote-commands'
      preLoaderRoute: typeof AuthenticatedRemoteCommandsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/realtime': {
      id: '/_authenticated/realtime'
      path: '/realtime'
      fullPath: '/realtime'
      preLoaderRoute: typeof AuthenticatedRealtimeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/points-dashboard': {
      id: '/_authenticated/points-dashboard'
      path: '/points-dashboard'
      fullPath: '/points-dashboard'
      preLoaderRoute: typeof AuthenticatedPointsDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/passwords': {
      id: '/_authenticated/passwords'
      path: '/passwords'
      fullPath: '/passwords'
      preLoaderRoute: typeof AuthenticatedPasswordsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/omnichannel-twilio-config': {
      id: '/_authenticated/omnichannel-twilio-config'
      path: '/omnichannel-twilio-config'
      fullPath: '/omnichannel-twilio-config'
      preLoaderRoute: typeof AuthenticatedOmnichannelTwilioConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/omnichannel-twilio': {
      id: '/_authenticated/omnichannel-twilio'
      path: '/omnichannel-twilio'
      fullPath: '/omnichannel-twilio'
      preLoaderRoute: typeof AuthenticatedOmnichannelTwilioRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/office-calendar-config': {
      id: '/_authenticated/office-calendar-config'
      path: '/office-calendar-config'
      fullPath: '/office-calendar-config'
      preLoaderRoute: typeof AuthenticatedOfficeCalendarConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notebook': {
      id: '/_authenticated/notebook'
      path: '/notebook'
      fullPath: '/notebook'
      preLoaderRoute: typeof AuthenticatedNotebookRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-requests': {
      id: '/_authenticated/my-requests'
      path: '/my-requests'
      fullPath: '/my-requests'
      preLoaderRoute: typeof AuthenticatedMyRequestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-passwords': {
      id: '/_authenticated/my-passwords'
      path: '/my-passwords'
      fullPath: '/my-passwords'
      preLoaderRoute: typeof AuthenticatedMyPasswordsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-dashboard': {
      id: '/_authenticated/my-dashboard'
      path: '/my-dashboard'
      fullPath: '/my-dashboard'
      preLoaderRoute: typeof AuthenticatedMyDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/minha-empresa': {
      id: '/_authenticated/minha-empresa'
      path: '/minha-empresa'
      fullPath: '/minha-empresa'
      preLoaderRoute: typeof AuthenticatedMinhaEmpresaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mindmaps': {
      id: '/_authenticated/mindmaps'
      path: '/mindmaps'
      fullPath: '/mindmaps'
      preLoaderRoute: typeof AuthenticatedMindmapsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/meta-omnichannel-config': {
      id: '/_authenticated/meta-omnichannel-config'
      path: '/meta-omnichannel-config'
      fullPath: '/meta-omnichannel-config'
      preLoaderRoute: typeof AuthenticatedMetaOmnichannelConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/meta-omnichannel': {
      id: '/_authenticated/meta-omnichannel'
      path: '/meta-omnichannel'
      fullPath: '/meta-omnichannel'
      preLoaderRoute: typeof AuthenticatedMetaOmnichannelRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mattermost-sync-channels': {
      id: '/_authenticated/mattermost-sync-channels'
      path: '/mattermost-sync-channels'
      fullPath: '/mattermost-sync-channels'
      preLoaderRoute: typeof AuthenticatedMattermostSyncChannelsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mattermost-scheduled-messages': {
      id: '/_authenticated/mattermost-scheduled-messages'
      path: '/mattermost-scheduled-messages'
      fullPath: '/mattermost-scheduled-messages'
      preLoaderRoute: typeof AuthenticatedMattermostScheduledMessagesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mattermost-image-validation': {
      id: '/_authenticated/mattermost-image-validation'
      path: '/mattermost-image-validation'
      fullPath: '/mattermost-image-validation'
      preLoaderRoute: typeof AuthenticatedMattermostImageValidationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mattermost-config': {
      id: '/_authenticated/mattermost-config'
      path: '/mattermost-config'
      fullPath: '/mattermost-config'
      preLoaderRoute: typeof AuthenticatedMattermostConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/kanban': {
      id: '/_authenticated/kanban'
      path: '/kanban'
      fullPath: '/kanban'
      preLoaderRoute: typeof AuthenticatedKanbanRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices': {
      id: '/_authenticated/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthenticatedInvoicesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/important-documents': {
      id: '/_authenticated/important-documents'
      path: '/important-documents'
      fullPath: '/important-documents'
      preLoaderRoute: typeof AuthenticatedImportantDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/google-drive-config': {
      id: '/_authenticated/google-drive-config'
      path: '/google-drive-config'
      fullPath: '/google-drive-config'
      preLoaderRoute: typeof AuthenticatedGoogleDriveConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/google-docs-config': {
      id: '/_authenticated/google-docs-config'
      path: '/google-docs-config'
      fullPath: '/google-docs-config'
      preLoaderRoute: typeof AuthenticatedGoogleDocsConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/gemini-config': {
      id: '/_authenticated/gemini-config'
      path: '/gemini-config'
      fullPath: '/gemini-config'
      preLoaderRoute: typeof AuthenticatedGeminiConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/external-integrations': {
      id: '/_authenticated/external-integrations'
      path: '/external-integrations'
      fullPath: '/external-integrations'
      preLoaderRoute: typeof AuthenticatedExternalIntegrationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/equipments': {
      id: '/_authenticated/equipments'
      path: '/equipments'
      fullPath: '/equipments'
      preLoaderRoute: typeof AuthenticatedEquipmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/drive-manager': {
      id: '/_authenticated/drive-manager'
      path: '/drive-manager'
      fullPath: '/drive-manager'
      preLoaderRoute: typeof AuthenticatedDriveManagerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents-management': {
      id: '/_authenticated/documents-management'
      path: '/documents-management'
      fullPath: '/documents-management'
      preLoaderRoute: typeof AuthenticatedDocumentsManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents-access-history': {
      id: '/_authenticated/documents-access-history'
      path: '/documents-access-history'
      fullPath: '/documents-access-history'
      preLoaderRoute: typeof AuthenticatedDocumentsAccessHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/desktop-versions': {
      id: '/_authenticated/desktop-versions'
      path: '/desktop-versions'
      fullPath: '/desktop-versions'
      preLoaderRoute: typeof AuthenticatedDesktopVersionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contract-management': {
      id: '/_authenticated/contract-management'
      path: '/contract-management'
      fullPath: '/contract-management'
      preLoaderRoute: typeof AuthenticatedContractManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/company-documents': {
      id: '/_authenticated/company-documents'
      path: '/company-documents'
      fullPath: '/company-documents'
      preLoaderRoute: typeof AuthenticatedCompanyDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/cnpj-search': {
      id: '/_authenticated/cnpj-search'
      path: '/cnpj-search'
      fullPath: '/cnpj-search'
      preLoaderRoute: typeof AuthenticatedCnpjSearchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/categories': {
      id: '/_authenticated/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof AuthenticatedCategoriesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar-config': {
      id: '/_authenticated/calendar-config'
      path: '/calendar-config'
      fullPath: '/calendar-config'
      preLoaderRoute: typeof AuthenticatedCalendarConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar-captations': {
      id: '/_authenticated/calendar-captations'
      path: '/calendar-captations'
      fullPath: '/calendar-captations'
      preLoaderRoute: typeof AuthenticatedCalendarCaptationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar-captation-approvals': {
      id: '/_authenticated/calendar-captation-approvals'
      path: '/calendar-captation-approvals'
      fullPath: '/calendar-captation-approvals'
      preLoaderRoute: typeof AuthenticatedCalendarCaptationApprovalsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calendar': {
      id: '/_authenticated/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AuthenticatedCalendarRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets': {
      id: '/_authenticated/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AuthenticatedAssetsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/asset-kits': {
      id: '/_authenticated/asset-kits'
      path: '/asset-kits'
      fullPath: '/asset-kits'
      preLoaderRoute: typeof AuthenticatedAssetKitsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin-tasks-board': {
      id: '/_authenticated/admin-tasks-board'
      path: '/admin-tasks-board'
      fullPath: '/admin-tasks-board'
      preLoaderRoute: typeof AuthenticatedAdminTasksBoardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin-dashboard': {
      id: '/_authenticated/admin-dashboard'
      path: '/admin-dashboard'
      fullPath: '/admin-dashboard'
      preLoaderRoute: typeof AuthenticatedAdminDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tech-systems/': {
      id: '/_authenticated/tech-systems/'
      path: '/tech-systems'
      fullPath: '/tech-systems/'
      preLoaderRoute: typeof AuthenticatedTechSystemsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playbooks/': {
      id: '/_authenticated/playbooks/'
      path: '/playbooks'
      fullPath: '/playbooks/'
      preLoaderRoute: typeof AuthenticatedPlaybooksIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pipeline/': {
      id: '/_authenticated/pipeline/'
      path: '/pipeline'
      fullPath: '/pipeline/'
      preLoaderRoute: typeof AuthenticatedPipelineIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-clients/': {
      id: '/_authenticated/my-clients/'
      path: '/my-clients'
      fullPath: '/my-clients/'
      preLoaderRoute: typeof AuthenticatedMyClientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/employees/': {
      id: '/_authenticated/employees/'
      path: '/employees'
      fullPath: '/employees/'
      preLoaderRoute: typeof AuthenticatedEmployeesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/': {
      id: '/_authenticated/contracts/'
      path: '/contracts'
      fullPath: '/contracts/'
      preLoaderRoute: typeof AuthenticatedContractsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contract-management/': {
      id: '/_authenticated/contract-management/'
      path: '/'
      fullPath: '/contract-management/'
      preLoaderRoute: typeof AuthenticatedContractManagementIndexRouteImport
      parentRoute: typeof AuthenticatedContractManagementRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients/': {
      id: '/_authenticated/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthenticatedClientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/client-invoices/': {
      id: '/_authenticated/client-invoices/'
      path: '/client-invoices'
      fullPath: '/client-invoices/'
      preLoaderRoute: typeof AuthenticatedClientInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/client-contracts/': {
      id: '/_authenticated/client-contracts/'
      path: '/client-contracts'
      fullPath: '/client-contracts/'
      preLoaderRoute: typeof AuthenticatedClientContractsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/certification/': {
      id: '/_authenticated/certification/'
      path: '/certification'
      fullPath: '/certification/'
      preLoaderRoute: typeof AuthenticatedCertificationIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai-analysis/': {
      id: '/_authenticated/ai-analysis/'
      path: '/ai-analysis'
      fullPath: '/ai-analysis/'
      preLoaderRoute: typeof AuthenticatedAiAnalysisIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/invite/$code/$tenantId': {
      id: '/invite/$code/$tenantId'
      path: '/invite/$code/$tenantId'
      fullPath: '/invite/$code/$tenantId'
      preLoaderRoute: typeof InviteCodeTenantIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/tech-systems/config': {
      id: '/_authenticated/tech-systems/config'
      path: '/tech-systems/config'
      fullPath: '/tech-systems/config'
      preLoaderRoute: typeof AuthenticatedTechSystemsConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tech-systems/$id': {
      id: '/_authenticated/tech-systems/$id'
      path: '/tech-systems/$id'
      fullPath: '/tech-systems/$id'
      preLoaderRoute: typeof AuthenticatedTechSystemsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/remote-access/$deviceId': {
      id: '/_authenticated/remote-access/$deviceId'
      path: '/remote-access/$deviceId'
      fullPath: '/remote-access/$deviceId'
      preLoaderRoute: typeof AuthenticatedRemoteAccessDeviceIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reimbursements/my-requests': {
      id: '/_authenticated/reimbursements/my-requests'
      path: '/reimbursements/my-requests'
      fullPath: '/reimbursements/my-requests'
      preLoaderRoute: typeof AuthenticatedReimbursementsMyRequestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reimbursements/analytics': {
      id: '/_authenticated/reimbursements/analytics'
      path: '/reimbursements/analytics'
      fullPath: '/reimbursements/analytics'
      preLoaderRoute: typeof AuthenticatedReimbursementsAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reimbursements/admin': {
      id: '/_authenticated/reimbursements/admin'
      path: '/reimbursements/admin'
      fullPath: '/reimbursements/admin'
      preLoaderRoute: typeof AuthenticatedReimbursementsAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playbooks/triggers': {
      id: '/_authenticated/playbooks/triggers'
      path: '/playbooks/triggers'
      fullPath: '/playbooks/triggers'
      preLoaderRoute: typeof AuthenticatedPlaybooksTriggersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playbooks/templates': {
      id: '/_authenticated/playbooks/templates'
      path: '/playbooks/templates'
      fullPath: '/playbooks/templates'
      preLoaderRoute: typeof AuthenticatedPlaybooksTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playbooks/new': {
      id: '/_authenticated/playbooks/new'
      path: '/playbooks/new'
      fullPath: '/playbooks/new'
      preLoaderRoute: typeof AuthenticatedPlaybooksNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playbooks/my-steps': {
      id: '/_authenticated/playbooks/my-steps'
      path: '/playbooks/my-steps'
      fullPath: '/playbooks/my-steps'
      preLoaderRoute: typeof AuthenticatedPlaybooksMyStepsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playbooks/config': {
      id: '/_authenticated/playbooks/config'
      path: '/playbooks/config'
      fullPath: '/playbooks/config'
      preLoaderRoute: typeof AuthenticatedPlaybooksConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playbooks/$id': {
      id: '/_authenticated/playbooks/$id'
      path: '/playbooks/$id'
      fullPath: '/playbooks/$id'
      preLoaderRoute: typeof AuthenticatedPlaybooksIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pipeline/kanban': {
      id: '/_authenticated/pipeline/kanban'
      path: '/pipeline/kanban'
      fullPath: '/pipeline/kanban'
      preLoaderRoute: typeof AuthenticatedPipelineKanbanRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-clients/$id': {
      id: '/_authenticated/my-clients/$id'
      path: '/my-clients/$id'
      fullPath: '/my-clients/$id'
      preLoaderRoute: typeof AuthenticatedMyClientsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mcp/authorize': {
      id: '/_authenticated/mcp/authorize'
      path: '/mcp/authorize'
      fullPath: '/mcp/authorize'
      preLoaderRoute: typeof AuthenticatedMcpAuthorizeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mattermost-scheduled-messages/new': {
      id: '/_authenticated/mattermost-scheduled-messages/new'
      path: '/new'
      fullPath: '/mattermost-scheduled-messages/new'
      preLoaderRoute: typeof AuthenticatedMattermostScheduledMessagesNewRouteImport
      parentRoute: typeof AuthenticatedMattermostScheduledMessagesRoute
    }
    '/_authenticated/employees/recess-control': {
      id: '/_authenticated/employees/recess-control'
      path: '/employees/recess-control'
      fullPath: '/employees/recess-control'
      preLoaderRoute: typeof AuthenticatedEmployeesRecessControlRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/employees/payments': {
      id: '/_authenticated/employees/payments'
      path: '/employees/payments'
      fullPath: '/employees/payments'
      preLoaderRoute: typeof AuthenticatedEmployeesPaymentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/employees/logs': {
      id: '/_authenticated/employees/logs'
      path: '/employees/logs'
      fullPath: '/employees/logs'
      preLoaderRoute: typeof AuthenticatedEmployeesLogsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/employees/$id': {
      id: '/_authenticated/employees/$id'
      path: '/employees/$id'
      fullPath: '/employees/$id'
      preLoaderRoute: typeof AuthenticatedEmployeesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/settings': {
      id: '/_authenticated/contracts/settings'
      path: '/contracts/settings'
      fullPath: '/contracts/settings'
      preLoaderRoute: typeof AuthenticatedContractsSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contracts/logs': {
      id: '/_authenticated/contracts/logs'
      path: '/contracts/logs'
      fullPath: '/contracts/logs'
      preLoaderRoute: typeof AuthenticatedContractsLogsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/$id': {
      id: '/_authenticated/companies/$id'
      path: '/companies/$id'
      fullPath: '/companies/$id'
      preLoaderRoute: typeof AuthenticatedCompaniesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients/board': {
      id: '/_authenticated/clients/board'
      path: '/clients/board'
      fullPath: '/clients/board'
      preLoaderRoute: typeof AuthenticatedClientsBoardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clients/$id': {
      id: '/_authenticated/clients/$id'
      path: '/clients/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof AuthenticatedClientsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/client-contracts/settings': {
      id: '/_authenticated/client-contracts/settings'
      path: '/client-contracts/settings'
      fullPath: '/client-contracts/settings'
      preLoaderRoute: typeof AuthenticatedClientContractsSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/client-contracts/history': {
      id: '/_authenticated/client-contracts/history'
      path: '/client-contracts/history'
      fullPath: '/client-contracts/history'
      preLoaderRoute: typeof AuthenticatedClientContractsHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai-analysis/settings': {
      id: '/_authenticated/ai-analysis/settings'
      path: '/ai-analysis/settings'
      fullPath: '/ai-analysis/settings'
      preLoaderRoute: typeof AuthenticatedAiAnalysisSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai-analysis/agents': {
      id: '/_authenticated/ai-analysis/agents'
      path: '/ai-analysis/agents'
      fullPath: '/ai-analysis/agents'
      preLoaderRoute: typeof AuthenticatedAiAnalysisAgentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/system-tenants': {
      id: '/_authenticated/admin/system-tenants'
      path: '/admin/system-tenants'
      fullPath: '/admin/system-tenants'
      preLoaderRoute: typeof AuthenticatedAdminSystemTenantsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/subscription': {
      id: '/_authenticated/admin/subscription'
      path: '/admin/subscription'
      fullPath: '/admin/subscription'
      preLoaderRoute: typeof AuthenticatedAdminSubscriptionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/store': {
      id: '/_authenticated/admin/store'
      path: '/admin/store'
      fullPath: '/admin/store'
      preLoaderRoute: typeof AuthenticatedAdminStoreRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/recurring-client-tasks': {
      id: '/_authenticated/admin/recurring-client-tasks'
      path: '/admin/recurring-client-tasks'
      fullPath: '/admin/recurring-client-tasks'
      preLoaderRoute: typeof AuthenticatedAdminRecurringClientTasksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/plans': {
      id: '/_authenticated/admin/plans'
      path: '/admin/plans'
      fullPath: '/admin/plans'
      preLoaderRoute: typeof AuthenticatedAdminPlansRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/office': {
      id: '/_authenticated/admin/office'
      path: '/admin/office'
      fullPath: '/admin/office'
      preLoaderRoute: typeof AuthenticatedAdminOfficeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/notion-config': {
      id: '/_authenticated/admin/notion-config'
      path: '/admin/notion-config'
      fullPath: '/admin/notion-config'
      preLoaderRoute: typeof AuthenticatedAdminNotionConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/mcp': {
      id: '/_authenticated/admin/mcp'
      path: '/admin/mcp'
      fullPath: '/admin/mcp'
      preLoaderRoute: typeof AuthenticatedAdminMcpRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/gamification-events': {
      id: '/_authenticated/admin/gamification-events'
      path: '/admin/gamification-events'
      fullPath: '/admin/gamification-events'
      preLoaderRoute: typeof AuthenticatedAdminGamificationEventsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/features': {
      id: '/_authenticated/admin/features'
      path: '/admin/features'
      fullPath: '/admin/features'
      preLoaderRoute: typeof AuthenticatedAdminFeaturesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/clients-config': {
      id: '/_authenticated/admin/clients-config'
      path: '/admin/clients-config'
      fullPath: '/admin/clients-config'
      preLoaderRoute: typeof AuthenticatedAdminClientsConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/branding': {
      id: '/_authenticated/admin/branding'
      path: '/admin/branding'
      fullPath: '/admin/branding'
      preLoaderRoute: typeof AuthenticatedAdminBrandingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/ai-credits': {
      id: '/_authenticated/admin/ai-credits'
      path: '/admin/ai-credits'
      fullPath: '/admin/ai-credits'
      preLoaderRoute: typeof AuthenticatedAdminAiCreditsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tech-systems/tickets/': {
      id: '/_authenticated/tech-systems/tickets/'
      path: '/tech-systems/tickets'
      fullPath: '/tech-systems/tickets/'
      preLoaderRoute: typeof AuthenticatedTechSystemsTicketsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tech-systems/templates/': {
      id: '/_authenticated/tech-systems/templates/'
      path: '/tech-systems/templates'
      fullPath: '/tech-systems/templates/'
      preLoaderRoute: typeof AuthenticatedTechSystemsTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tech-systems/projects/': {
      id: '/_authenticated/tech-systems/projects/'
      path: '/tech-systems/projects'
      fullPath: '/tech-systems/projects/'
      preLoaderRoute: typeof AuthenticatedTechSystemsProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pipeline/leads/': {
      id: '/_authenticated/pipeline/leads/'
      path: '/pipeline/leads'
      fullPath: '/pipeline/leads/'
      preLoaderRoute: typeof AuthenticatedPipelineLeadsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pipeline/assets/': {
      id: '/_authenticated/pipeline/assets/'
      path: '/pipeline/assets'
      fullPath: '/pipeline/assets/'
      preLoaderRoute: typeof AuthenticatedPipelineAssetsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/certification/manage/': {
      id: '/_authenticated/certification/manage/'
      path: '/certification/manage'
      fullPath: '/certification/manage/'
      preLoaderRoute: typeof AuthenticatedCertificationManageIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/invoices/': {
      id: '/_authenticated/admin/invoices/'
      path: '/admin/invoices'
      fullPath: '/admin/invoices/'
      preLoaderRoute: typeof AuthenticatedAdminInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tech-systems/tickets/finance': {
      id: '/_authenticated/tech-systems/tickets/finance'
      path: '/tech-systems/tickets/finance'
      fullPath: '/tech-systems/tickets/finance'
      preLoaderRoute: typeof AuthenticatedTechSystemsTicketsFinanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tech-systems/tickets/$ticketId': {
      id: '/_authenticated/tech-systems/tickets/$ticketId'
      path: '/tech-systems/tickets/$ticketId'
      fullPath: '/tech-systems/tickets/$ticketId'
      preLoaderRoute: typeof AuthenticatedTechSystemsTicketsTicketIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tech-systems/templates/$id': {
      id: '/_authenticated/tech-systems/templates/$id'
      path: '/tech-systems/templates/$id'
      fullPath: '/tech-systems/templates/$id'
      preLoaderRoute: typeof AuthenticatedTechSystemsTemplatesIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tech-systems/projects/$id': {
      id: '/_authenticated/tech-systems/projects/$id'
      path: '/tech-systems/projects/$id'
      fullPath: '/tech-systems/projects/$id'
      preLoaderRoute: typeof AuthenticatedTechSystemsProjectsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playbooks/tasks/mine': {
      id: '/_authenticated/playbooks/tasks/mine'
      path: '/playbooks/tasks/mine'
      fullPath: '/playbooks/tasks/mine'
      preLoaderRoute: typeof AuthenticatedPlaybooksTasksMineRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pipeline/leads/novo': {
      id: '/_authenticated/pipeline/leads/novo'
      path: '/pipeline/leads/novo'
      fullPath: '/pipeline/leads/novo'
      preLoaderRoute: typeof AuthenticatedPipelineLeadsNovoRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pipeline/leads/$id': {
      id: '/_authenticated/pipeline/leads/$id'
      path: '/pipeline/leads/$id'
      fullPath: '/pipeline/leads/$id'
      preLoaderRoute: typeof AuthenticatedPipelineLeadsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pipeline/assets/novo': {
      id: '/_authenticated/pipeline/assets/novo'
      path: '/pipeline/assets/novo'
      fullPath: '/pipeline/assets/novo'
      preLoaderRoute: typeof AuthenticatedPipelineAssetsNovoRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pipeline/assets/$id': {
      id: '/_authenticated/pipeline/assets/$id'
      path: '/pipeline/assets/$id'
      fullPath: '/pipeline/assets/$id'
      preLoaderRoute: typeof AuthenticatedPipelineAssetsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/contract-management/templates/new': {
      id: '/_authenticated/contract-management/templates/new'
      path: '/templates/new'
      fullPath: '/contract-management/templates/new'
      preLoaderRoute: typeof AuthenticatedContractManagementTemplatesNewRouteImport
      parentRoute: typeof AuthenticatedContractManagementRoute
    }
    '/_authenticated/contract-management/templates/$id': {
      id: '/_authenticated/contract-management/templates/$id'
      path: '/templates/$id'
      fullPath: '/contract-management/templates/$id'
      preLoaderRoute: typeof AuthenticatedContractManagementTemplatesIdRouteImport
      parentRoute: typeof AuthenticatedContractManagementRoute
    }
    '/_authenticated/contract-management/contracts/$id': {
      id: '/_authenticated/contract-management/contracts/$id'
      path: '/contracts/$id'
      fullPath: '/contract-management/contracts/$id'
      preLoaderRoute: typeof AuthenticatedContractManagementContractsIdRouteImport
      parentRoute: typeof AuthenticatedContractManagementRoute
    }
    '/_authenticated/certification/courses/$courseId': {
      id: '/_authenticated/certification/courses/$courseId'
      path: '/certification/courses/$courseId'
      fullPath: '/certification/courses/$courseId'
      preLoaderRoute: typeof AuthenticatedCertificationCoursesCourseIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/certification/certificados/$certificateId': {
      id: '/_authenticated/certification/certificados/$certificateId'
      path: '/certification/certificados/$certificateId'
      fullPath: '/certification/certificados/$certificateId'
      preLoaderRoute: typeof AuthenticatedCertificationCertificadosCertificateIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/invoices/missing': {
      id: '/_authenticated/admin/invoices/missing'
      path: '/admin/invoices/missing'
      fullPath: '/admin/invoices/missing'
      preLoaderRoute: typeof AuthenticatedAdminInvoicesMissingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/invoices/submitted/': {
      id: '/_authenticated/admin/invoices/submitted/'
      path: '/admin/invoices/submitted'
      fullPath: '/admin/invoices/submitted/'
      preLoaderRoute: typeof AuthenticatedAdminInvoicesSubmittedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/certification/courses/$courseId/simulado': {
      id: '/_authenticated/certification/courses/$courseId/simulado'
      path: '/simulado'
      fullPath: '/certification/courses/$courseId/simulado'
      preLoaderRoute: typeof AuthenticatedCertificationCoursesCourseIdSimuladoRouteImport
      parentRoute: typeof AuthenticatedCertificationCoursesCourseIdRoute
    }
    '/_authenticated/admin/invoices/submitted/$userId': {
      id: '/_authenticated/admin/invoices/submitted/$userId'
      path: '/admin/invoices/submitted/$userId'
      fullPath: '/admin/invoices/submitted/$userId'
      preLoaderRoute: typeof AuthenticatedAdminInvoicesSubmittedUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface SystemRouteRouteChildren {
  SystemAiCreditPackagesRoute: typeof SystemAiCreditPackagesRoute
  SystemDevicesRoute: typeof SystemDevicesRoute
  SystemLogsRoute: typeof SystemLogsRoute
  SystemPlansRoute: typeof SystemPlansRoute
  SystemSettingsRoute: typeof SystemSettingsRoute
  SystemSupportRoute: typeof SystemSupportRoute
  SystemTenantUsageRoute: typeof SystemTenantUsageRoute
  SystemTenantsRoute: typeof SystemTenantsRoute
  SystemUsersRoute: typeof SystemUsersRoute
  SystemIndexRoute: typeof SystemIndexRoute
}

const SystemRouteRouteChildren: SystemRouteRouteChildren = {
  SystemAiCreditPackagesRoute: SystemAiCreditPackagesRoute,
  SystemDevicesRoute: SystemDevicesRoute,
  SystemLogsRoute: SystemLogsRoute,
  SystemPlansRoute: SystemPlansRoute,
  SystemSettingsRoute: SystemSettingsRoute,
  SystemSupportRoute: SystemSupportRoute,
  SystemTenantUsageRoute: SystemTenantUsageRoute,
  SystemTenantsRoute: SystemTenantsRoute,
  SystemUsersRoute: SystemUsersRoute,
  SystemIndexRoute: SystemIndexRoute,
}

const SystemRouteRouteWithChildren = SystemRouteRoute._addFileChildren(
  SystemRouteRouteChildren,
)

interface AuthenticatedContractManagementRouteChildren {
  AuthenticatedContractManagementIndexRoute: typeof AuthenticatedContractManagementIndexRoute
  AuthenticatedContractManagementContractsIdRoute: typeof AuthenticatedContractManagementContractsIdRoute
  AuthenticatedContractManagementTemplatesIdRoute: typeof AuthenticatedContractManagementTemplatesIdRoute
  AuthenticatedContractManagementTemplatesNewRoute: typeof AuthenticatedContractManagementTemplatesNewRoute
}

const AuthenticatedContractManagementRouteChildren: AuthenticatedContractManagementRouteChildren =
  {
    AuthenticatedContractManagementIndexRoute:
      AuthenticatedContractManagementIndexRoute,
    AuthenticatedContractManagementContractsIdRoute:
      AuthenticatedContractManagementContractsIdRoute,
    AuthenticatedContractManagementTemplatesIdRoute:
      AuthenticatedContractManagementTemplatesIdRoute,
    AuthenticatedContractManagementTemplatesNewRoute:
      AuthenticatedContractManagementTemplatesNewRoute,
  }

const AuthenticatedContractManagementRouteWithChildren =
  AuthenticatedContractManagementRoute._addFileChildren(
    AuthenticatedContractManagementRouteChildren,
  )

interface AuthenticatedMattermostScheduledMessagesRouteChildren {
  AuthenticatedMattermostScheduledMessagesNewRoute: typeof AuthenticatedMattermostScheduledMessagesNewRoute
}

const AuthenticatedMattermostScheduledMessagesRouteChildren: AuthenticatedMattermostScheduledMessagesRouteChildren =
  {
    AuthenticatedMattermostScheduledMessagesNewRoute:
      AuthenticatedMattermostScheduledMessagesNewRoute,
  }

const AuthenticatedMattermostScheduledMessagesRouteWithChildren =
  AuthenticatedMattermostScheduledMessagesRoute._addFileChildren(
    AuthenticatedMattermostScheduledMessagesRouteChildren,
  )

interface AuthenticatedCertificationCoursesCourseIdRouteChildren {
  AuthenticatedCertificationCoursesCourseIdSimuladoRoute: typeof AuthenticatedCertificationCoursesCourseIdSimuladoRoute
}

const AuthenticatedCertificationCoursesCourseIdRouteChildren: AuthenticatedCertificationCoursesCourseIdRouteChildren =
  {
    AuthenticatedCertificationCoursesCourseIdSimuladoRoute:
      AuthenticatedCertificationCoursesCourseIdSimuladoRoute,
  }

const AuthenticatedCertificationCoursesCourseIdRouteWithChildren =
  AuthenticatedCertificationCoursesCourseIdRoute._addFileChildren(
    AuthenticatedCertificationCoursesCourseIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminDashboardRoute: typeof AuthenticatedAdminDashboardRoute
  AuthenticatedAdminTasksBoardRoute: typeof AuthenticatedAdminTasksBoardRoute
  AuthenticatedAssetKitsRoute: typeof AuthenticatedAssetKitsRoute
  AuthenticatedAssetsRoute: typeof AuthenticatedAssetsRoute
  AuthenticatedCalendarRoute: typeof AuthenticatedCalendarRoute
  AuthenticatedCalendarCaptationApprovalsRoute: typeof AuthenticatedCalendarCaptationApprovalsRoute
  AuthenticatedCalendarCaptationsRoute: typeof AuthenticatedCalendarCaptationsRoute
  AuthenticatedCalendarConfigRoute: typeof AuthenticatedCalendarConfigRoute
  AuthenticatedCategoriesRoute: typeof AuthenticatedCategoriesRoute
  AuthenticatedCnpjSearchRoute: typeof AuthenticatedCnpjSearchRoute
  AuthenticatedCompanyDocumentsRoute: typeof AuthenticatedCompanyDocumentsRoute
  AuthenticatedContractManagementRoute: typeof AuthenticatedContractManagementRouteWithChildren
  AuthenticatedDesktopVersionsRoute: typeof AuthenticatedDesktopVersionsRoute
  AuthenticatedDocumentsAccessHistoryRoute: typeof AuthenticatedDocumentsAccessHistoryRoute
  AuthenticatedDocumentsManagementRoute: typeof AuthenticatedDocumentsManagementRoute
  AuthenticatedDriveManagerRoute: typeof AuthenticatedDriveManagerRoute
  AuthenticatedEquipmentsRoute: typeof AuthenticatedEquipmentsRoute
  AuthenticatedExternalIntegrationsRoute: typeof AuthenticatedExternalIntegrationsRoute
  AuthenticatedGeminiConfigRoute: typeof AuthenticatedGeminiConfigRoute
  AuthenticatedGoogleDocsConfigRoute: typeof AuthenticatedGoogleDocsConfigRoute
  AuthenticatedGoogleDriveConfigRoute: typeof AuthenticatedGoogleDriveConfigRoute
  AuthenticatedImportantDocumentsRoute: typeof AuthenticatedImportantDocumentsRoute
  AuthenticatedInvoicesRoute: typeof AuthenticatedInvoicesRoute
  AuthenticatedKanbanRoute: typeof AuthenticatedKanbanRoute
  AuthenticatedMattermostConfigRoute: typeof AuthenticatedMattermostConfigRoute
  AuthenticatedMattermostImageValidationRoute: typeof AuthenticatedMattermostImageValidationRoute
  AuthenticatedMattermostScheduledMessagesRoute: typeof AuthenticatedMattermostScheduledMessagesRouteWithChildren
  AuthenticatedMattermostSyncChannelsRoute: typeof AuthenticatedMattermostSyncChannelsRoute
  AuthenticatedMetaOmnichannelRoute: typeof AuthenticatedMetaOmnichannelRoute
  AuthenticatedMetaOmnichannelConfigRoute: typeof AuthenticatedMetaOmnichannelConfigRoute
  AuthenticatedMindmapsRoute: typeof AuthenticatedMindmapsRoute
  AuthenticatedMinhaEmpresaRoute: typeof AuthenticatedMinhaEmpresaRoute
  AuthenticatedMyDashboardRoute: typeof AuthenticatedMyDashboardRoute
  AuthenticatedMyPasswordsRoute: typeof AuthenticatedMyPasswordsRoute
  AuthenticatedMyRequestsRoute: typeof AuthenticatedMyRequestsRoute
  AuthenticatedNotebookRoute: typeof AuthenticatedNotebookRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedOfficeCalendarConfigRoute: typeof AuthenticatedOfficeCalendarConfigRoute
  AuthenticatedOmnichannelTwilioRoute: typeof AuthenticatedOmnichannelTwilioRoute
  AuthenticatedOmnichannelTwilioConfigRoute: typeof AuthenticatedOmnichannelTwilioConfigRoute
  AuthenticatedPasswordsRoute: typeof AuthenticatedPasswordsRoute
  AuthenticatedPointsDashboardRoute: typeof AuthenticatedPointsDashboardRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedRealtimeRoute: typeof AuthenticatedRealtimeRoute
  AuthenticatedRemoteCommandsRoute: typeof AuthenticatedRemoteCommandsRoute
  AuthenticatedRequestsRoute: typeof AuthenticatedRequestsRoute
  AuthenticatedRolesRoute: typeof AuthenticatedRolesRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedStoreRoute: typeof AuthenticatedStoreRoute
  AuthenticatedTaskManagementRoute: typeof AuthenticatedTaskManagementRoute
  AuthenticatedTaskPlanningCalendarRoute: typeof AuthenticatedTaskPlanningCalendarRoute
  AuthenticatedTasksBoardRoute: typeof AuthenticatedTasksBoardRoute
  AuthenticatedTasksHistoryRoute: typeof AuthenticatedTasksHistoryRoute
  AuthenticatedTeamCalendarRoute: typeof AuthenticatedTeamCalendarRoute
  AuthenticatedTeamsRoute: typeof AuthenticatedTeamsRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedUsersBirthdaysRoute: typeof AuthenticatedUsersBirthdaysRoute
  AuthenticatedWhatsappConfigRoute: typeof AuthenticatedWhatsappConfigRoute
  AuthenticatedAdminAiCreditsRoute: typeof AuthenticatedAdminAiCreditsRoute
  AuthenticatedAdminBrandingRoute: typeof AuthenticatedAdminBrandingRoute
  AuthenticatedAdminClientsConfigRoute: typeof AuthenticatedAdminClientsConfigRoute
  AuthenticatedAdminFeaturesRoute: typeof AuthenticatedAdminFeaturesRoute
  AuthenticatedAdminGamificationEventsRoute: typeof AuthenticatedAdminGamificationEventsRoute
  AuthenticatedAdminMcpRoute: typeof AuthenticatedAdminMcpRoute
  AuthenticatedAdminNotionConfigRoute: typeof AuthenticatedAdminNotionConfigRoute
  AuthenticatedAdminOfficeRoute: typeof AuthenticatedAdminOfficeRoute
  AuthenticatedAdminPlansRoute: typeof AuthenticatedAdminPlansRoute
  AuthenticatedAdminRecurringClientTasksRoute: typeof AuthenticatedAdminRecurringClientTasksRoute
  AuthenticatedAdminStoreRoute: typeof AuthenticatedAdminStoreRoute
  AuthenticatedAdminSubscriptionRoute: typeof AuthenticatedAdminSubscriptionRoute
  AuthenticatedAdminSystemTenantsRoute: typeof AuthenticatedAdminSystemTenantsRoute
  AuthenticatedAiAnalysisAgentsRoute: typeof AuthenticatedAiAnalysisAgentsRoute
  AuthenticatedAiAnalysisSettingsRoute: typeof AuthenticatedAiAnalysisSettingsRoute
  AuthenticatedClientContractsHistoryRoute: typeof AuthenticatedClientContractsHistoryRoute
  AuthenticatedClientContractsSettingsRoute: typeof AuthenticatedClientContractsSettingsRoute
  AuthenticatedClientsIdRoute: typeof AuthenticatedClientsIdRoute
  AuthenticatedClientsBoardRoute: typeof AuthenticatedClientsBoardRoute
  AuthenticatedCompaniesIdRoute: typeof AuthenticatedCompaniesIdRoute
  AuthenticatedContractsLogsRoute: typeof AuthenticatedContractsLogsRoute
  AuthenticatedContractsSettingsRoute: typeof AuthenticatedContractsSettingsRoute
  AuthenticatedEmployeesIdRoute: typeof AuthenticatedEmployeesIdRoute
  AuthenticatedEmployeesLogsRoute: typeof AuthenticatedEmployeesLogsRoute
  AuthenticatedEmployeesPaymentsRoute: typeof AuthenticatedEmployeesPaymentsRoute
  AuthenticatedEmployeesRecessControlRoute: typeof AuthenticatedEmployeesRecessControlRoute
  AuthenticatedMcpAuthorizeRoute: typeof AuthenticatedMcpAuthorizeRoute
  AuthenticatedMyClientsIdRoute: typeof AuthenticatedMyClientsIdRoute
  AuthenticatedPipelineKanbanRoute: typeof AuthenticatedPipelineKanbanRoute
  AuthenticatedPlaybooksIdRoute: typeof AuthenticatedPlaybooksIdRoute
  AuthenticatedPlaybooksConfigRoute: typeof AuthenticatedPlaybooksConfigRoute
  AuthenticatedPlaybooksMyStepsRoute: typeof AuthenticatedPlaybooksMyStepsRoute
  AuthenticatedPlaybooksNewRoute: typeof AuthenticatedPlaybooksNewRoute
  AuthenticatedPlaybooksTemplatesRoute: typeof AuthenticatedPlaybooksTemplatesRoute
  AuthenticatedPlaybooksTriggersRoute: typeof AuthenticatedPlaybooksTriggersRoute
  AuthenticatedReimbursementsAdminRoute: typeof AuthenticatedReimbursementsAdminRoute
  AuthenticatedReimbursementsAnalyticsRoute: typeof AuthenticatedReimbursementsAnalyticsRoute
  AuthenticatedReimbursementsMyRequestsRoute: typeof AuthenticatedReimbursementsMyRequestsRoute
  AuthenticatedRemoteAccessDeviceIdRoute: typeof AuthenticatedRemoteAccessDeviceIdRoute
  AuthenticatedTechSystemsIdRoute: typeof AuthenticatedTechSystemsIdRoute
  AuthenticatedTechSystemsConfigRoute: typeof AuthenticatedTechSystemsConfigRoute
  AuthenticatedAiAnalysisIndexRoute: typeof AuthenticatedAiAnalysisIndexRoute
  AuthenticatedCertificationIndexRoute: typeof AuthenticatedCertificationIndexRoute
  AuthenticatedClientContractsIndexRoute: typeof AuthenticatedClientContractsIndexRoute
  AuthenticatedClientInvoicesIndexRoute: typeof AuthenticatedClientInvoicesIndexRoute
  AuthenticatedClientsIndexRoute: typeof AuthenticatedClientsIndexRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedContractsIndexRoute: typeof AuthenticatedContractsIndexRoute
  AuthenticatedEmployeesIndexRoute: typeof AuthenticatedEmployeesIndexRoute
  AuthenticatedMyClientsIndexRoute: typeof AuthenticatedMyClientsIndexRoute
  AuthenticatedPipelineIndexRoute: typeof AuthenticatedPipelineIndexRoute
  AuthenticatedPlaybooksIndexRoute: typeof AuthenticatedPlaybooksIndexRoute
  AuthenticatedTechSystemsIndexRoute: typeof AuthenticatedTechSystemsIndexRoute
  AuthenticatedAdminInvoicesMissingRoute: typeof AuthenticatedAdminInvoicesMissingRoute
  AuthenticatedCertificationCertificadosCertificateIdRoute: typeof AuthenticatedCertificationCertificadosCertificateIdRoute
  AuthenticatedCertificationCoursesCourseIdRoute: typeof AuthenticatedCertificationCoursesCourseIdRouteWithChildren
  AuthenticatedPipelineAssetsIdRoute: typeof AuthenticatedPipelineAssetsIdRoute
  AuthenticatedPipelineAssetsNovoRoute: typeof AuthenticatedPipelineAssetsNovoRoute
  AuthenticatedPipelineLeadsIdRoute: typeof AuthenticatedPipelineLeadsIdRoute
  AuthenticatedPipelineLeadsNovoRoute: typeof AuthenticatedPipelineLeadsNovoRoute
  AuthenticatedPlaybooksTasksMineRoute: typeof AuthenticatedPlaybooksTasksMineRoute
  AuthenticatedTechSystemsProjectsIdRoute: typeof AuthenticatedTechSystemsProjectsIdRoute
  AuthenticatedTechSystemsTemplatesIdRoute: typeof AuthenticatedTechSystemsTemplatesIdRoute
  AuthenticatedTechSystemsTicketsTicketIdRoute: typeof AuthenticatedTechSystemsTicketsTicketIdRoute
  AuthenticatedTechSystemsTicketsFinanceRoute: typeof AuthenticatedTechSystemsTicketsFinanceRoute
  AuthenticatedAdminInvoicesIndexRoute: typeof AuthenticatedAdminInvoicesIndexRoute
  AuthenticatedCertificationManageIndexRoute: typeof AuthenticatedCertificationManageIndexRoute
  AuthenticatedPipelineAssetsIndexRoute: typeof AuthenticatedPipelineAssetsIndexRoute
  AuthenticatedPipelineLeadsIndexRoute: typeof AuthenticatedPipelineLeadsIndexRoute
  AuthenticatedTechSystemsProjectsIndexRoute: typeof AuthenticatedTechSystemsProjectsIndexRoute
  AuthenticatedTechSystemsTemplatesIndexRoute: typeof AuthenticatedTechSystemsTemplatesIndexRoute
  AuthenticatedTechSystemsTicketsIndexRoute: typeof AuthenticatedTechSystemsTicketsIndexRoute
  AuthenticatedAdminInvoicesSubmittedUserIdRoute: typeof AuthenticatedAdminInvoicesSubmittedUserIdRoute
  AuthenticatedAdminInvoicesSubmittedIndexRoute: typeof AuthenticatedAdminInvoicesSubmittedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminDashboardRoute: AuthenticatedAdminDashboardRoute,
  AuthenticatedAdminTasksBoardRoute: AuthenticatedAdminTasksBoardRoute,
  AuthenticatedAssetKitsRoute: AuthenticatedAssetKitsRoute,
  AuthenticatedAssetsRoute: AuthenticatedAssetsRoute,
  AuthenticatedCalendarRoute: AuthenticatedCalendarRoute,
  AuthenticatedCalendarCaptationApprovalsRoute:
    AuthenticatedCalendarCaptationApprovalsRoute,
  AuthenticatedCalendarCaptationsRoute: AuthenticatedCalendarCaptationsRoute,
  AuthenticatedCalendarConfigRoute: AuthenticatedCalendarConfigRoute,
  AuthenticatedCategoriesRoute: AuthenticatedCategoriesRoute,
  AuthenticatedCnpjSearchRoute: AuthenticatedCnpjSearchRoute,
  AuthenticatedCompanyDocumentsRoute: AuthenticatedCompanyDocumentsRoute,
  AuthenticatedContractManagementRoute:
    AuthenticatedContractManagementRouteWithChildren,
  AuthenticatedDesktopVersionsRoute: AuthenticatedDesktopVersionsRoute,
  AuthenticatedDocumentsAccessHistoryRoute:
    AuthenticatedDocumentsAccessHistoryRoute,
  AuthenticatedDocumentsManagementRoute: AuthenticatedDocumentsManagementRoute,
  AuthenticatedDriveManagerRoute: AuthenticatedDriveManagerRoute,
  AuthenticatedEquipmentsRoute: AuthenticatedEquipmentsRoute,
  AuthenticatedExternalIntegrationsRoute:
    AuthenticatedExternalIntegrationsRoute,
  AuthenticatedGeminiConfigRoute: AuthenticatedGeminiConfigRoute,
  AuthenticatedGoogleDocsConfigRoute: AuthenticatedGoogleDocsConfigRoute,
  AuthenticatedGoogleDriveConfigRoute: AuthenticatedGoogleDriveConfigRoute,
  AuthenticatedImportantDocumentsRoute: AuthenticatedImportantDocumentsRoute,
  AuthenticatedInvoicesRoute: AuthenticatedInvoicesRoute,
  AuthenticatedKanbanRoute: AuthenticatedKanbanRoute,
  AuthenticatedMattermostConfigRoute: AuthenticatedMattermostConfigRoute,
  AuthenticatedMattermostImageValidationRoute:
    AuthenticatedMattermostImageValidationRoute,
  AuthenticatedMattermostScheduledMessagesRoute:
    AuthenticatedMattermostScheduledMessagesRouteWithChildren,
  AuthenticatedMattermostSyncChannelsRoute:
    AuthenticatedMattermostSyncChannelsRoute,
  AuthenticatedMetaOmnichannelRoute: AuthenticatedMetaOmnichannelRoute,
  AuthenticatedMetaOmnichannelConfigRoute:
    AuthenticatedMetaOmnichannelConfigRoute,
  AuthenticatedMindmapsRoute: AuthenticatedMindmapsRoute,
  AuthenticatedMinhaEmpresaRoute: AuthenticatedMinhaEmpresaRoute,
  AuthenticatedMyDashboardRoute: AuthenticatedMyDashboardRoute,
  AuthenticatedMyPasswordsRoute: AuthenticatedMyPasswordsRoute,
  AuthenticatedMyRequestsRoute: AuthenticatedMyRequestsRoute,
  AuthenticatedNotebookRoute: AuthenticatedNotebookRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedOfficeCalendarConfigRoute:
    AuthenticatedOfficeCalendarConfigRoute,
  AuthenticatedOmnichannelTwilioRoute: AuthenticatedOmnichannelTwilioRoute,
  AuthenticatedOmnichannelTwilioConfigRoute:
    AuthenticatedOmnichannelTwilioConfigRoute,
  AuthenticatedPasswordsRoute: AuthenticatedPasswordsRoute,
  AuthenticatedPointsDashboardRoute: AuthenticatedPointsDashboardRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedRealtimeRoute: AuthenticatedRealtimeRoute,
  AuthenticatedRemoteCommandsRoute: AuthenticatedRemoteCommandsRoute,
  AuthenticatedRequestsRoute: AuthenticatedRequestsRoute,
  AuthenticatedRolesRoute: AuthenticatedRolesRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedStoreRoute: AuthenticatedStoreRoute,
  AuthenticatedTaskManagementRoute: AuthenticatedTaskManagementRoute,
  AuthenticatedTaskPlanningCalendarRoute:
    AuthenticatedTaskPlanningCalendarRoute,
  AuthenticatedTasksBoardRoute: AuthenticatedTasksBoardRoute,
  AuthenticatedTasksHistoryRoute: AuthenticatedTasksHistoryRoute,
  AuthenticatedTeamCalendarRoute: AuthenticatedTeamCalendarRoute,
  AuthenticatedTeamsRoute: AuthenticatedTeamsRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedUsersBirthdaysRoute: AuthenticatedUsersBirthdaysRoute,
  AuthenticatedWhatsappConfigRoute: AuthenticatedWhatsappConfigRoute,
  AuthenticatedAdminAiCreditsRoute: AuthenticatedAdminAiCreditsRoute,
  AuthenticatedAdminBrandingRoute: AuthenticatedAdminBrandingRoute,
  AuthenticatedAdminClientsConfigRoute: AuthenticatedAdminClientsConfigRoute,
  AuthenticatedAdminFeaturesRoute: AuthenticatedAdminFeaturesRoute,
  AuthenticatedAdminGamificationEventsRoute:
    AuthenticatedAdminGamificationEventsRoute,
  AuthenticatedAdminMcpRoute: AuthenticatedAdminMcpRoute,
  AuthenticatedAdminNotionConfigRoute: AuthenticatedAdminNotionConfigRoute,
  AuthenticatedAdminOfficeRoute: AuthenticatedAdminOfficeRoute,
  AuthenticatedAdminPlansRoute: AuthenticatedAdminPlansRoute,
  AuthenticatedAdminRecurringClientTasksRoute:
    AuthenticatedAdminRecurringClientTasksRoute,
  AuthenticatedAdminStoreRoute: AuthenticatedAdminStoreRoute,
  AuthenticatedAdminSubscriptionRoute: AuthenticatedAdminSubscriptionRoute,
  AuthenticatedAdminSystemTenantsRoute: AuthenticatedAdminSystemTenantsRoute,
  AuthenticatedAiAnalysisAgentsRoute: AuthenticatedAiAnalysisAgentsRoute,
  AuthenticatedAiAnalysisSettingsRoute: AuthenticatedAiAnalysisSettingsRoute,
  AuthenticatedClientContractsHistoryRoute:
    AuthenticatedClientContractsHistoryRoute,
  AuthenticatedClientContractsSettingsRoute:
    AuthenticatedClientContractsSettingsRoute,
  AuthenticatedClientsIdRoute: AuthenticatedClientsIdRoute,
  AuthenticatedClientsBoardRoute: AuthenticatedClientsBoardRoute,
  AuthenticatedCompaniesIdRoute: AuthenticatedCompaniesIdRoute,
  AuthenticatedContractsLogsRoute: AuthenticatedContractsLogsRoute,
  AuthenticatedContractsSettingsRoute: AuthenticatedContractsSettingsRoute,
  AuthenticatedEmployeesIdRoute: AuthenticatedEmployeesIdRoute,
  AuthenticatedEmployeesLogsRoute: AuthenticatedEmployeesLogsRoute,
  AuthenticatedEmployeesPaymentsRoute: AuthenticatedEmployeesPaymentsRoute,
  AuthenticatedEmployeesRecessControlRoute:
    AuthenticatedEmployeesRecessControlRoute,
  AuthenticatedMcpAuthorizeRoute: AuthenticatedMcpAuthorizeRoute,
  AuthenticatedMyClientsIdRoute: AuthenticatedMyClientsIdRoute,
  AuthenticatedPipelineKanbanRoute: AuthenticatedPipelineKanbanRoute,
  AuthenticatedPlaybooksIdRoute: AuthenticatedPlaybooksIdRoute,
  AuthenticatedPlaybooksConfigRoute: AuthenticatedPlaybooksConfigRoute,
  AuthenticatedPlaybooksMyStepsRoute: AuthenticatedPlaybooksMyStepsRoute,
  AuthenticatedPlaybooksNewRoute: AuthenticatedPlaybooksNewRoute,
  AuthenticatedPlaybooksTemplatesRoute: AuthenticatedPlaybooksTemplatesRoute,
  AuthenticatedPlaybooksTriggersRoute: AuthenticatedPlaybooksTriggersRoute,
  AuthenticatedReimbursementsAdminRoute: AuthenticatedReimbursementsAdminRoute,
  AuthenticatedReimbursementsAnalyticsRoute:
    AuthenticatedReimbursementsAnalyticsRoute,
  AuthenticatedReimbursementsMyRequestsRoute:
    AuthenticatedReimbursementsMyRequestsRoute,
  AuthenticatedRemoteAccessDeviceIdRoute:
    AuthenticatedRemoteAccessDeviceIdRoute,
  AuthenticatedTechSystemsIdRoute: AuthenticatedTechSystemsIdRoute,
  AuthenticatedTechSystemsConfigRoute: AuthenticatedTechSystemsConfigRoute,
  AuthenticatedAiAnalysisIndexRoute: AuthenticatedAiAnalysisIndexRoute,
  AuthenticatedCertificationIndexRoute: AuthenticatedCertificationIndexRoute,
  AuthenticatedClientContractsIndexRoute:
    AuthenticatedClientContractsIndexRoute,
  AuthenticatedClientInvoicesIndexRoute: AuthenticatedClientInvoicesIndexRoute,
  AuthenticatedClientsIndexRoute: AuthenticatedClientsIndexRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedContractsIndexRoute: AuthenticatedContractsIndexRoute,
  AuthenticatedEmployeesIndexRoute: AuthenticatedEmployeesIndexRoute,
  AuthenticatedMyClientsIndexRoute: AuthenticatedMyClientsIndexRoute,
  AuthenticatedPipelineIndexRoute: AuthenticatedPipelineIndexRoute,
  AuthenticatedPlaybooksIndexRoute: AuthenticatedPlaybooksIndexRoute,
  AuthenticatedTechSystemsIndexRoute: AuthenticatedTechSystemsIndexRoute,
  AuthenticatedAdminInvoicesMissingRoute:
    AuthenticatedAdminInvoicesMissingRoute,
  AuthenticatedCertificationCertificadosCertificateIdRoute:
    AuthenticatedCertificationCertificadosCertificateIdRoute,
  AuthenticatedCertificationCoursesCourseIdRoute:
    AuthenticatedCertificationCoursesCourseIdRouteWithChildren,
  AuthenticatedPipelineAssetsIdRoute: AuthenticatedPipelineAssetsIdRoute,
  AuthenticatedPipelineAssetsNovoRoute: AuthenticatedPipelineAssetsNovoRoute,
  AuthenticatedPipelineLeadsIdRoute: AuthenticatedPipelineLeadsIdRoute,
  AuthenticatedPipelineLeadsNovoRoute: AuthenticatedPipelineLeadsNovoRoute,
  AuthenticatedPlaybooksTasksMineRoute: AuthenticatedPlaybooksTasksMineRoute,
  AuthenticatedTechSystemsProjectsIdRoute:
    AuthenticatedTechSystemsProjectsIdRoute,
  AuthenticatedTechSystemsTemplatesIdRoute:
    AuthenticatedTechSystemsTemplatesIdRoute,
  AuthenticatedTechSystemsTicketsTicketIdRoute:
    AuthenticatedTechSystemsTicketsTicketIdRoute,
  AuthenticatedTechSystemsTicketsFinanceRoute:
    AuthenticatedTechSystemsTicketsFinanceRoute,
  AuthenticatedAdminInvoicesIndexRoute: AuthenticatedAdminInvoicesIndexRoute,
  AuthenticatedCertificationManageIndexRoute:
    AuthenticatedCertificationManageIndexRoute,
  AuthenticatedPipelineAssetsIndexRoute: AuthenticatedPipelineAssetsIndexRoute,
  AuthenticatedPipelineLeadsIndexRoute: AuthenticatedPipelineLeadsIndexRoute,
  AuthenticatedTechSystemsProjectsIndexRoute:
    AuthenticatedTechSystemsProjectsIndexRoute,
  AuthenticatedTechSystemsTemplatesIndexRoute:
    AuthenticatedTechSystemsTemplatesIndexRoute,
  AuthenticatedTechSystemsTicketsIndexRoute:
    AuthenticatedTechSystemsTicketsIndexRoute,
  AuthenticatedAdminInvoicesSubmittedUserIdRoute:
    AuthenticatedAdminInvoicesSubmittedUserIdRoute,
  AuthenticatedAdminInvoicesSubmittedIndexRoute:
    AuthenticatedAdminInvoicesSubmittedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SystemRouteRoute: SystemRouteRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CalendarOauthCallbackRoute: CalendarOauthCallbackRoute,
  ExclusaoDeDadosRoute: ExclusaoDeDadosRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  GoogleDriveOauthCallbackRoute: GoogleDriveOauthCallbackRoute,
  LoginRoute: LoginRoute,
  PoliticaCookieRoute: PoliticaCookieRoute,
  PoliticaPrivacidadeRoute: PoliticaPrivacidadeRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SsoRoute: SsoRoute,
  SystemLoginRoute: SystemLoginRoute,
  TermosDeUsoRoute: TermosDeUsoRoute,
  InviteCodeTenantIdRoute: InviteCodeTenantIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
